import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
  TextField,
  FormControl,
  Radio,
  TextareaAutosize,
  OutlinedInput,
  Icon,
  Chip,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Autocomplete,
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import dayjs from 'dayjs'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import WarningDialog from "../../../components/WarningConfirm";
import SimpleDialog from "../../../components/SimpleDialog";
import MoreDetailCustom from "../../../components/kpi/MoreDetailCustom";
import { useTranslation } from "react-i18next";
import { getGoalType, getDropdownMetric, getDropdownUnit, getGroupCategory, getCategoryWeight, getEvaluatorList, getMemberList, getMemberTeamList, postCreateMyGoal, getScaleLevel, getAlignmentList, getGoalForEdit, putEditMyGoal, getCustomForm } from "../../../actions/mygoal";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../icons/arrow-left.svg";
import { ReactComponent as CloseButtonIcon } from "../../../icons/close-green.svg";
import { makeStyles } from "@mui/styles";
import { ReactComponent as LinkActive } from "../../../icons/link-goal-active.svg";
import { ReactComponent as LinkInactive } from "../../../icons/link-goal-inactive.svg";
import { ReactComponent as CasActive } from "../../../icons/cas-active.svg";
import { ReactComponent as CasInactive } from "../../../icons/cas-inactive.svg";
import { ReactComponent as InNoneAlign } from "../../../icons/innone-align.svg";
import { ReactComponent as NoneAlign } from "../../../icons/none-align.svg";
import { ReactComponent as PersonalActive } from "../../../icons/personal-active.svg";
import { ReactComponent as TeamActive } from "../../../icons/team-active.svg";
import { ReactComponent as CompActive } from "../../../icons/comp-active.svg";
import * as Util from "../../../services/global.service";
import { styled } from "@mui/material/styles";

// import axios from "axios";
const MyGoalCreateForm = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { id } = useParams();
  const { state } = useLocation();
  const goalDetailRef = useRef(null)
  const moreDetailRef = useRef(null)
  const goalMemberRef = useRef(null)
  const goalWeightRef = useRef(null)
  const goalTypeRef = useRef(null)
  const goalScaleRef = useRef(null)

  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
    memberSearch: {
      maxHeight: '300px',
      padding: '37px',
      width: "99%",
      minHeight: "50px",
      background: "#FFF",
      zIndex: "10",
      webkitBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      mozBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      boxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      overflow: 'hidden',
      marginLeft: '20px'
    },
    alignmentSearch: {
      maxHeight: '300px',
      padding: '37px',
      width: "99%",
      minHeight: "50px",
      background: "#FFF",
      zIndex: "10",
      webkitBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      mozBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      boxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      overflow: 'hidden',
      marginLeft: '15px',
    },
    notchedOutline: {
      borderColor: "#5DA196 !important"
    }
  };

  const useStyles = makeStyles({
    closeSvg: {
      "& > path": {
        fill: "#5DA196"
      },
      '& g > path': {
        fill: '#5DA196'
      },
    },
    customTextField: {
      "& input::placeholder": {
        fontSize: "16px",
        color: '#A3A3A3',
      }
    },
    disabled: {
      background: "#F3F3F3!important"
    },
    error: {
      color: " #CC6058 !important",
    },
    '& ::placeholder': {
      color: '#A3A3A3 !important'
    },
    '& Mui-disabled': {
      background: "#F3F3F3!important"
    }
  })

  const classes = useStyles();


  // Function Start

  // Common Start
  const goto = (route, data) => {
    if (route) {
      if (route === 'mygoal' && state.isEvaluator && state.formEvaluateId) route += '/' + state.formEvaluateId

      route = '/' + route
    }

    //console.log('goto', route, data); return;
    navigate("/kpi" + route, { replace: false, state: data });
  }

  const isEmpty = (data) => {
    if (data == null || data == "" || data.length == 0 || !data) {
      return true
    } else
      return false
  }

  const confirmPage = () => {
    console.log('confirmPage')
    const goalMetricSerial = respOption.find((item) => { if (item.code === goalMetric.toLowerCase()) { return item.serial } }).serial
    // let sendEvaluatorSerial = "";
    // if(evaluator) {
    //   sendEvaluatorSerial = selectOption?.evaluator.find((item) => {if((`${item.firstName} ${item.lastName}`) === evaluator) return item}).serial
    // }
    const scaleForConvert = [...scaleLevel]
    const scaleLevelFilter = scaleForConvert.filter((item) => item.max_value !== null)
    const scaleConvertDate = scaleLevelFilter.map((item) => {
      if (goalMetric.toLowerCase() === 'date') {
        const scaleDate = {
          value_min: dayjs(item.min_value).format('DD/MM/YYYY'),
          value_max: dayjs(item.max_value).format('DD/MM/YYYY'),
          serial: item.serial
        }
        return scaleDate;
      } else {
        const scaleValue = {
          value_min: item.min_value,
          value_max: item.max_value,
          serial: item.serial
        }
        return scaleValue
      }
    })
    let goalMetricUnit = "";
    let goalTypeSerial = "";
    if (unit) {
      // goalMetricUnit = selectOption?.unit?.find((item) => {if(item.serial === unit) {return item.serial}})?.serial
      // console.log(selectOption.unit, unit)
      // console.log(goalMetricUnit)
    }
    if (goalType === 3 || goalType === 2 || goalType === 1) {
      const goalTypeList = { ...selectOption };
      const goalTypeData = goalTypeList.goalType.filter((item) => item.code === (goalType === 3 ? 'personal' : goalType === 2 ? 'team' : 'corporate'))[0]
      goalTypeSerial = goalTypeData.serial
    } else {
      goalTypeSerial = goalType
    }
    const memberAdd = memberList.map((item) => {
      if (!item.goalCategoryDetail) {
        return { member_id: item.serial || undefined, template_category_id: item.selectGoalCategory, goal_id: kpiGoalId, form_goal_id: item.goalSerial, form_evaluate_id: item.formEvaluateID }
      }
    }).filter((item) => item)
    const alignmentAdd = alignmentList.map((item) => {
      if (!item.goalCategoryDetail) {
        return { member_id: item.serial || undefined, template_category_id: item.selectGoalCategory, goal_id: kpiGoalId, form_goal_id: item.goalSerial, form_evaluate_id: item.formEvaluateID }
      }
    }).filter((item) => item)


    var data = {
      more_detail: moreDetail.length > 0 ? moreDetail : [],
      measurement: measurement,
      remark: remark,
      goal_detail: {
        goal_name: goalName,
        goal_details: goalDetail,
        start_date: dayjs(startDate).format('YYYY-MM-DD'),
        end_date: dayjs(endDate).format('YYYY-MM-DD'),
        goal_metric: goalMetricSerial,
        target_condition: condition?.toLowerCase() || "",
        unit: unit,
        specify_unit: others || "",
        target_value: targetValue,
        measurement: measurement,
        remark: remark,
        more_detail: moreDetail.length > 0 ? moreDetail : [],
      },
      goal_category: {
        kpi_goal_template_category_id: goalCategoryOptions.find((item) => (item.code === goalCategory || item.serial === goalCategory)).serial,
        evaluation_weight: weight.toString(),
      },
      scale_level: scaleLevelCheckbox ? scaleConvertDate : [],
      goal_type: goalTypeSerial,
      suggestion_type: "",
      goal_template_id: goalTemplateSerial,
      goal_master_id: goalMasterSerial || "",
      kpi_form_evaluate_id: evaluatorSerial,
      cycle_id: cycleId,
      goal_member: {
        add: memberAdd.length > 0 ? memberAdd : undefined,
        remove: removeMembers.length > 0 ? removeMembers.map((item) => {
          return { member_id: item.serial || undefined, template_category_id: item?.goalCategoryDetail?.serial, goal_id: kpiGoalId, form_goal_id: item.goalSerial, form_evaluate_id: item.formEvaluateID }
        }) : undefined
      },
      evaluator_permission: {
        evaluator: evaluator ? (evaluator.serial || evaluator) : "",
        permission: permission?.toLowerCase() || "private",
      },
      linking_goal: {
        linking_goal_type: type === 'Associated Goal'
          ? 'linking_associate'
          : type === 'Parent Goal'
            ? 'linking_parent' : undefined,
        linked_goal: value ? (value.serial || value) : undefined
      },
      cascade_goal: {
        assigned_type: alignmentList.length > 0 ? "cascading" : undefined,
        // assigned_members: alignmentList.length > 0 ? alignmentList.map((item) => item.serial) : undefined
        add: alignmentAdd.length > 0 ? alignmentAdd : undefined,
        remove: removeAlignments.length > 0 ? removeAlignments.map((item) => {
          return { member_id: item.serial || undefined, template_category_id: item?.goalCategoryDetail?.serial, goal_id: kpiGoalId, form_goal_id: item.goalSerial, form_evaluate_id: item.formEvaluateID }
        }) : undefined
      },
      is_cascade_goal: isCascade,
      is_linking_goal: isLinking,
      kpi_form_id: kpiFormId,
    }
    if (id === 'edit') {
      Object.assign(data, {
        update_data: {
          goal_serial: kpiGoalId,
          goal_form_serial: state.goalSerial
        }
      })
      dispatch(putEditMyGoal(state.goalSerial, data))
        .then(resp => {
          if (resp.success) {
            openConfirmEditOpen(false)
            openSuccessEditOpen(true)
          }
        })
    } else {
      dispatch(postCreateMyGoal(data))
        .then(resp => {
          if (resp.success) {
            goto('mygoal-create-success', state)
          }
        })
    }
  }

  const chooseLibrary = (val) => {
    setCancascading(val?.options?.cascading)
    setGoalType(val?.id)
  }

  const chooseCategory = async (serial, categoryData) => {

    /*
    let categorySerial = null
    for (const cat of goalCategoryOptions) {
      if (cat.serial === serial) categorySerial = cat.serial
    }
    */
    setCategory(serial)


    var weightValue = null;
    var memberLists = [...memberList];
    var alignmentLists = [...alignmentList];
    await dispatch(getCategoryWeight(serial, state.serial, state.goalSerial))
      .then(resp => {
        setCategoryWeightValue(categoryData?.categorySerial)
        weightValue = categoryData?.categorySerial;
        if (resp.data.goalCategoryWeight.weight) {

          let w = 100 - resp.data.goalCategoryWeight.weight
          w = Math.round(w * 100) / 100
          setCategoryWeight(w);
        } else {
          setCategoryWeight(100)
        }
      })
    if (memberLists.length > 0) {
      memberLists = memberLists.map((item) => {
        if (item?.empCategories?.some((data) => data.serial === serial)) {
          item.selectGoalCategory = serial
        } else if (item?.empCategories?.some((data) => data.value === weightValue)) {
          item.selectGoalCategory = item?.empCategories?.find((item) => item.value === weightValue).serial
        }
        return item;
      })
      setMemberList(memberLists)
    }
    if (alignmentLists.length > 0) {
      alignmentLists = alignmentLists.map((item) => {
        if (item?.empCategories?.some((data) => data.serial === serial)) {
          item.selectGoalCategory = serial
        } else if (item?.empCategories?.some((data) => data.value === weightValue)) {
          item.selectGoalCategory = item?.empCategories?.find((item) => item.value === weightValue).serial
        }
        return item;
      })
      setAlignmentList(alignmentLists)
      setBackupAlignmentList(alignmentList)
    }
  }

  const handleSuccessEdit = () => {
    openSuccessEditOpen(false)
    goto('mygoal', state);
  };
  // Common End

  // Varify & Set Data Start
  const numberIsEmpty = (scaleLevelList) => {
    var empty = false;
    scaleLevelList.map((scaleLevel, idx) => {
      if (scaleLevel.min_value == null || scaleLevel.max_value == null || !scaleLevel.min_value || !scaleLevel.max_value) {
        empty = true;
      }
    })
    return empty;
  }
  const numberNotOverlap = (scaleLevelList) => {
    var overlap = false;
    var orderScaleLevel = 'asc';
    scaleLevelList.map((scaleLevel, idx) => {
      if (idx == 0) {
        if (parseFloat(scaleLevelList[idx + 1]?.min_value) - parseFloat(scaleLevelList[idx]?.max_value) > 0) {
          orderScaleLevel = 'asc';
          setOrderScale('asc')
        } else {
          orderScaleLevel = 'desc';
          setOrderScale('desc')
        }
      } else {
        if (parseFloat(scaleLevel.max_value) - parseFloat(scaleLevel.min_value) < 0) {
          overlap = true;
        }
        if (orderScaleLevel == 'asc') {
          if (idx + 1 !== scaleLevelList.length) {
            if (parseFloat(scaleLevelList[idx + 1]?.min_value) - parseFloat(scaleLevelList[idx]?.max_value) <= 0) {
              overlap = true;
            }
            if (parseFloat(scaleLevelList[idx + 1]?.max_value) - parseFloat(scaleLevelList[idx]?.min_value) <= 0) {
              overlap = true;
            }
          }
        } else {
          if (idx + 1 !== scaleLevelList.length) {
            if (parseFloat(scaleLevelList[idx + 1]?.min_value) - parseFloat(scaleLevelList[idx]?.max_value) > 0) {
              overlap = true;
            }
            if (parseFloat(scaleLevelList[idx + 1]?.max_value) - parseFloat(scaleLevelList[idx]?.min_value) > 0) {
              overlap = true;
            }
          }
        }
      }
    })
    return overlap;
  }
  const dateNotOverlap = (scaleLevelList) => {
    var overlap = false;
    scaleLevelList.map((scaleLevel, idx) => {
      if (dayjs(scaleLevel.min_value).diff(dayjs(scaleLevel.max_value), 'day') > 0) {
        overlap = true;
      }
      if (idx < scaleLevelList.length && idx > 0) {
        if (dayjs(scaleLevel.min_value).diff(dayjs(scaleLevelList[idx - 1].max_value), 'day') <= 0) {
          overlap = true;
        }
      }
    })
    return overlap;
  }

  const checkField = () => {
    var data = {}
    if (isEmpty(goalType) && id == "guide") {
      data = Object.assign(data, { goalType: true })
    }
    if (isEmpty(goalName)) {
      data = Object.assign(data, { name: true })
    }
    if (isEmpty(goalDetail)) {
      data = Object.assign(data, { detail: true })
    }
    if (isEmpty(measurement)) {
      data = Object.assign(data, { measurement: true })
    }
    if (isEmpty(startDate)) {
      data = Object.assign(data, { startDate: true })
    }
    if (isEmpty(endDate)) {
      data = Object.assign(data, { endDate: true })
    }
    if (isEmpty(goalMetric)) {
      data = Object.assign(data, { goalMetric: true })
    }
    if (isEmpty(remark) && state.isEvaluator) {
      data = Object.assign(data, { remark: true })
    }


    // New Data
    if (moreDetail.length > 0) {
      let moreData = [];
      moreDetail.map((item) => {
        let empty = false;
        if (isEmpty(item.value) && item.is_required) {
          empty = true;
          moreData.push(empty)
        }
      })
      if (moreData.length > 0) {
        data = Object.assign(data, { moreDetail: moreData })
      }
    }

    if (goalMetric == 'Value') {
      if ((unit == 'Custom' || unit == 'custom') && isEmpty(others)) {
        data = Object.assign(data, { others: true })
      }
      if (isEmpty(condition)) {
        data = Object.assign(data, { condition: true })
      }
      if (isEmpty(unit)) {
        data = Object.assign(data, { unit: true })
      }
      if (isEmpty(targetValue)) {
        data = Object.assign(data, { targetValue: true })
      } else {
        const unitOption = selectOption?.unitOption?.filter((item) => { if (item.serial === unit) return item })[0]
        const min = unitOption?.options?.min_value || 0;
        if (targetValue < min) {
          data = Object.assign(data, { targetValue: true })
        }
      }
    }
    if (goalType == 2) {
      if (isEmpty(memberList) && isOwner) {
        data = Object.assign(data, { member: true })
      }
      var goalCategoryEmpty = memberList.some((item) => { if (!item.goalCategoryDetail) return isEmpty(item.selectGoalCategory) })
      if (goalCategoryEmpty) {
        data = Object.assign(data, { selectGoalCategory: true })
      }
    }
    if (isEmpty(goalCategory)) {
      data = Object.assign(data, { goalCategory: true })
    }
    if (isEmpty(weight) || ((goalCategory === backupCategory) ? categoryWeight - weight < 0 : categoryWeight - weight < 0)) {
      data = Object.assign(data, { weight: true })
    }
    if (scaleLevelCheckbox) {
      if (goalMetric == 'Date') {
        if (numberIsEmpty(scaleLevel)) {
          data = Object.assign(data, { scaleLevelEmpty: true })
        } else if (dateNotOverlap(scaleLevel)) {
          data = Object.assign(data, { scaleLevel: true })
        }
      } else if (goalMetric == 'Value') {
        if (numberIsEmpty(scaleLevel)) {
          data = Object.assign(data, { scaleLevelEmpty: true })
        } else if (numberNotOverlap(scaleLevel)) {
          data = Object.assign(data, { scaleLevel: true })
        }
      }
    }
    if (isLinking) {
      if (isEmpty(type) || isEmpty(value)) {
        data = Object.assign(data, { alignment: true })
      }
    } else if (isCascade) {
      if (isEmpty(alignmentList) && (goalType !== 1 && id !== 'edit')) {
        data = Object.assign(data, { alignment: true })
      }
      var goalCategoryEmpty = alignmentList.some((item) => { if (!item.goalCategoryDetail) return isEmpty(item.selectGoalCategory) })
      if (goalCategoryEmpty) {
        data = Object.assign(data, { selectAlignmentGoalCategory: true })
      }
    }

    if (Object.keys(data).length != 0 && data.goalType) {
      goalTypeRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0
      && (data.name || data.detail || data.measurement || data.startDate || data.endDate || data.goalMetric || data.condition || data.unit || data.targetValue || data.others)) {
      goalDetailRef.current.scrollIntoView({ behavior: 'smooth' })
    }
    // New Data
    else if (Object.keys(data).length != 0
      && (data?.moreDetail?.some((data) => data))) {
      moreDetailRef.current.scrollIntoView({ behavior: 'smooth' })
    }
    else if (Object.keys(data).length != 0 && (data.scaleLevel || data.scaleLevelEmpty) && scaleLevelCheckbox) {
      goalScaleRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && memberList.length === 0 && (goalType == 1 || goalType == 2) && isOwner) {
      goalMemberRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && (data.weight || data.goalCategory)) {
      goalWeightRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    if (Object.keys(data).length == 0) {
      if (id === 'edit') {
        openConfirmEditOpen(true);
      } else {
        confirmPage()
      }
    }

    setVerifyField(data)
  }

  const handleChangeObject = (value, idx, type) => {
    if (type === 'member') {
      var cloneMemberList = [...memberList];
      cloneMemberList[idx].selectGoalCategory = value;
      setMemberList(cloneMemberList)
    } else if (type === 'alignment') {
      var cloneAlignmentList = [...alignmentList];
      cloneAlignmentList[idx].selectGoalCategory = value;
      setAlignmentList(cloneAlignmentList)
      setBackupAlignmentList(cloneAlignmentList)
    }
  }

  const checkLinking = () => {
    if (isLinking) {
      setType("")
      setValue(null)
    }
    setIsLinking(!isLinking)
  }

  const checkCascade = () => {
    if (isCascade) {
      setAlignmentList(backupAlignmentList)
      setRemoveAlignments([])
    }
    setIsCascade(!isCascade)
  }

  const handleChange = (value, type) => {
    setChanging(true);
    var stateOption = { ...selectOption };
    if (type == 'evaluator') {
      setEvaluator(value)
    } else if (type == 'metric') {
      setGoalMetric(value)
      const emptyScaleLevel = scaleLevel.map((item) => { return { min_value: null, max_value: null, serial: item.serial, level: item.level } });
      setScaleLevel(emptyScaleLevel)
      if (value == 'Value') {
        setTargetValue("")
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '40' },
          { min_value: '41', max_value: '60' },
          { min_value: '61', max_value: '80' },
          { min_value: '81', max_value: '100' },
        ])
        if (respOption) {
          respOption.map((data) => {
            if (data.code == value.toLowerCase() && data.options != null) {
              var stateOptions = { ...selectOption }
              stateOptions['condition'] = data.options.target_condition;
              setSelectOption(stateOptions)
            }
          })
        }
      } else if (value == 'Date') {
        setUnit(null)
        setCondition(null)
        setTargetValue(endDate != null ? dayjs(endDate).format('DD/MM/YYYY') : "")
        setScaleCondition([
          { min_value: '01/01/2020', max_value: '31/01/2020' },
          { min_value: '01/02/2020', max_value: '28/02/2020' },
          { min_value: '01/03/2020', max_value: '31/03/2020' },
          { min_value: '01/04/2020', max_value: '30/04/2020' },
          { min_value: '01/05/2020', max_value: '31/05/2020' },
        ])
      } else if (value == 'Accomplishment') {
        setUnit(null)
        setCondition(null)
        setTargetValue('Success')
      }
    } else if (type == 'unit') {
      setUnit(value)
      setOthers("")
      setScaleCondition([
        { min_value: '1', max_value: '20' },
        { min_value: '21', max_value: '40' },
        { min_value: '41', max_value: '60' },
        { min_value: '61', max_value: '80' },
        { min_value: '81', max_value: '100' },
      ])
      if (value.code == 'Minute') {
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '30' },
          { min_value: '31', max_value: '40' },
          { min_value: '41', max_value: '50' },
          { min_value: '51', max_value: '60' },
        ])
      } else if (value.code == 'Hours') {
        setScaleCondition([
          { min_value: '1', max_value: '4' },
          { min_value: '5', max_value: '8' },
          { min_value: '9', max_value: '12' },
          { min_value: '13', max_value: '16' },
          { min_value: '17', max_value: '24' },
        ])
      } else if (value.code == 'Score') {
        setScaleCondition([
          { min_value: '1', max_value: '200' },
          { min_value: '201', max_value: '400' },
          { min_value: '401', max_value: '600' },
          { min_value: '601', max_value: '800' },
          { min_value: '801', max_value: '1000' },
        ])
      }
    } else if (type == 'condition') {
      setCondition(value)
    } else if (type == 'memberType') {
      setMemberType(value)
      stateOption['member'] = memberOption
      setSelectOption(stateOption);
    } else if (type == 'member') {
      setMember(value)
    } else if (type == 'permission') {
      setPermission(value)
    } else if (type == 'type') {
      if (isCascade) {
        stateOption['value'] = value == 'Member' ? memberOption : memberTeamOption
      }
      setType(value)
    } else if (type == 'value') {
      setValue(value)
    }
  };

  const changeMoreDetail = (value, item, idx) => {
    let moreDetailStruct = [...moreDetail]

    if (item.type === 'text') {
      item.value = value;
      moreDetailStruct[idx] = item;
    } else if (item.type === 'dropdown') {
      item.value = value;
      moreDetailStruct[idx] = item;
    } else if (item.type === 'textarea') {
      item.value = value;
      moreDetailStruct[idx] = item;
    } else if (item.type === 'number') {
      if (value === null || value === "") {
        item.value = "";
      } else {
        item.value = value.replace(/[^\d.]|\.(?=.*\.)/g, '');
      }
      moreDetailStruct[idx] = item;
    }

    setMoreDetail(moreDetailStruct)
  }

  const changeValue = (value, type) => {
    setChanging(true);
    if (type == 'name') {
      setGoalName(value)
    } else if (type == 'detail') {
      setGoalDetail(value)
    } else if (type == 'measurement') {
      setMeasurement(value)
    } else if (type == 'remark') {
      setRemark(value)
    } else if (type == 'others') {
      setOthers(value)
    } else if (type == 'targetValue') {
      value = value.replace(/[^\d.]|\.(?=.*\.)/g, '')
      setTargetValue(value)
    } else if (type == 'weight') {
      if (value && value.indexOf('.') > 0) {
        const idxDot = value.indexOf('.');
        if (idxDot + 1 === value.length) {
          setWeight(value)
        }
        if (idxDot + 2 === value.length) {
          setWeight(parseFloat(value).toFixed(1))
        }
      } else if (value === null || value === "") {
        setWeight("")
      } else {
        setWeight(value.replace(/[^\d.]|\.(?=.*\.)/g, ''))
      }
    }
  }

  const changeScaleLevel = (value, type, idx) => {
    var scaleLevelData = [...scaleLevel];

    if (goalMetric === 'Date') {
      console.log(value)
      if (type == `scaleMin`) {
        scaleLevelData[idx]['min_value'] = dayjs(value).format('MM/DD/YYYY')
        console.log('min', scaleLevelData[idx]['min_value'])
      } else if (type == `scaleMax`) {
        scaleLevelData[idx]['max_value'] = dayjs(value).format('MM/DD/YYYY')
        console.log('max', scaleLevelData[idx]['max_value'])
      }
    } else if (goalMetric === 'Value') {
      if (type == `scaleMin`) {
        let min;
        const idxDot = value.split('.');
        if (value && value.indexOf('.') > 0) {
          if (idxDot[1] && idxDot[1].length === 1) {
            min = value
          } else if (idxDot[1] && idxDot[1].length === 2) {
            min = parseFloat(value).toFixed(2)
          } else if (idxDot[1] && idxDot[1].length === 3) {
            min = parseFloat(value).toFixed(3)
          } else if (idxDot[1] && idxDot[1].length === 4) {
            min = parseFloat(value).toFixed(4)
          }
        } else if (value === null || value === "") {
          min = ""
        }
        if (idxDot[1] && idxDot[1].length > 0) {
          if (min)
            min = min.replace(/[^\d.]|\.(?=.*\.)/g, '')
          else
            min = value.substr(0, value.length - 1).replace(/[^\d.]|\.(?=.*\.)/g, '')
        } else {
          min = value.replace(/[^\d.]|\.(?=.*\.)/g, '')
        }
        scaleLevelData[idx]['min_value'] = min
      } else if (type == `scaleMax`) {
        let max;
        const idxDot = value.split('.');
        if (value && value.indexOf('.') > 0) {
          if (idxDot[1] && idxDot[1].length === 1) {
            max = value
          } else if (idxDot[1] && idxDot[1].length === 2) {
            max = parseFloat(value).toFixed(2)
          } else if (idxDot[1] && idxDot[1].length === 3) {
            max = parseFloat(value).toFixed(3)
          } else if (idxDot[1] && idxDot[1].length === 4) {
            max = parseFloat(value).toFixed(4)
          }
        } else if (value === null || value === "") {
          max = ""
        }
        if (idxDot[1] && idxDot[1].length > 0) {
          if (max)
            max = max.replace(/[^\d.]|\.(?=.*\.)/g, '')
          else
            max = value.substr(0, value.length - 1).replace(/[^\d.]|\.(?=.*\.)/g, '')
        } else {
          max = value.replace(/[^\d.]|\.(?=.*\.)/g, '')
        }
        scaleLevelData[idx]['max_value'] = max
      }
    }

    setScaleLevel(scaleLevelData)
  }

  const valueCondition = () => {
    let text = ''
    if (unit == 'Percentage') {
      text = "0.00 - 100.00"
    } else if (unit == 'Minute') {
      text = "0.00 - 100.00"
    } else if (unit == 'Hour') {
      text = "0.00 - 100.00"
    } else if (unit == 'Day') {
      text = "0.00 - 100.00"
    } else if (unit == 'Score') {
      text = "0 - 1,000.00"
    } else if (unit == 'Client') {
      text = "0 - 100,000.00"
    } else if (unit == 'Count') {
      text = "0 - 100,000.00"
    } else if (unit == 'THB') {
      text = "0 - 1,000,000,000.00"
    } else if (unit == 'USD') {
      text = "0 - 1,000,000,000.00"
    } else if (unit == 'Others') {
      text = "0 - 1,000,000,000.00"
    }
    return <Typography style={{ fontSize: 14, color: '#404349' }}>{text}</Typography>
  }

  const addDate = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const setValueFromAnotherPage = () => {
    if (state) {
      setGoalName(state.name ?? state.goalName);
      setGoalDetail(state.description ?? state.goalDetail);
      if (state?.metric) {
        var metric = (state.metric.description === 'ทำได้ตัวเลขตามเป้าหมาย' || state.metric.description === 'Value') ? 'Value' : (state.metric.description === 'ทำได้ภายใน End Date' || state.metric.description === 'Date') ? 'Date' : 'Accomplishment'
        handleChange(metric, 'metric')
      }

      if (state?.cycle_id) setCycleId(state.cycle_id)
      if (state?.serial) setEvaluatorSerial(state.serial)
      if (state?.kpiFormId) setKpiFormId(state.kpiFormId)
      if (state?.condition) setCondition(state.condition);
      // if(state?.evaluator) {
      //   setEvaluator(state?.evaluator?.full_name);
      // }
      if (state?.defaultCategory) {
        setCategory(state?.defaultCategory);
      } else if (state.goalCategory) {
        setCategory(state.goalCategory);
      } else setCategory(null)
      // if(state?.start_date) setStartDate(Util.formatDate2(state.start_date));
      // if(state?.end_date) setEndDate(Util.formatDate2(state.end_date));
      if (state?.goalType) {
        setGoalType(state?.sendGoalType ?? state.goalType);
      }
      if ((state?.type ? Object.keys(state.type).length > 0 : false) && !state?.sendGoalType) {
        //console.log('setGoalType', state?.type?.code === 'team' ? 2 : state?.type.code === 'personal' ? 3 : state?.type?.code === 'corperate' ? 1 : null)

        setGoalType(state.type.serial)
        //setGoalType(state?.type?.code === 'team' ? 2 : state?.type.code === 'personal' ? 3 : state?.type?.code === 'corperate' ? 1 : null)
      }
      if (state?.member) setMember(state.member);
      setMemberType(state.memberType);
      setOthers(state.others);
      if (state?.permission) setPermission(state.permission);
      if (state?.target_value) setTargetValue(state.target_value);
      if (state?.unit ? Object.keys(state?.unit).length > 0 : false) {
        setUnit(state.unit.serial)
      }
      if (state?.weight) setWeight(state?.weight);
      if (state.scaleLevel) setScaleLevel(state.scaleLevel);
      if (state.categoryWeight) setCategoryWeight(state.categoryWeight)
      setSelectOption(state.selectOption)
      // setGoalCategoryOptions(state.goalCategoryOptions)
      setMemberTeamOption(state.memberTeamOption)
      // setMemberOption(state.memberOption)
      if (state?.librarySerial) setGoalMasterSerial(state?.librarySerial)
    }
  }

  const setValueFromForEdit = (data, membersData, alignmentsData, categoryOptionData, goalTypeList) => {
    console.log('setValueFromForEdit')
    const goalDetailEdit = data;
    if (Object.keys(goalDetailEdit).length > 0) {

      if (goalDetailEdit?.goal_template_id) {
        setGoalTemplateSerial(goalDetailEdit?.goal_template_id)
      }

      if (goalDetailEdit?.goal_detail?.unit) {
        setUnit(goalDetailEdit?.goal_detail?.unit)
      }
      if (goalDetailEdit?.goal_detail?.target_condition) {
        setCondition(goalDetailEdit?.goal_detail?.target_condition.charAt(0).toUpperCase() + goalDetailEdit?.goal_detail?.target_condition.slice(1))
      }
      if (goalDetailEdit?.goal_category?.kpi_goal_template_category_id) {
        chooseCategory(goalDetailEdit?.goal_category?.kpi_goal_template_category_id, goalDetailEdit?.goal_category);
        setBackupCategory(goalDetailEdit?.goal_category?.kpi_goal_template_category_id);
      }
      if (goalDetailEdit?.goal_member?.members?.length > 0) {
        if (membersData) {
          const originalData = goalDetailEdit?.goal_member?.members;
          console.log('originalData', originalData)

          for (const member of originalData) {
            console.log('data.form_evaluate_id', member.form_evaluate_id, member.template_category_id)

            const info = membersData.find((item) => { return item.formEvaluateID === member.form_evaluate_id })
            console.log(membersData)
          }

          const memberData = membersData.filter((item) => {
            return originalData.find((data) => {
              if (data.form_evaluate_id === item.formEvaluateID) {
                item.goalCategoryDetail = categoryOptionData?.find((cate) => {
                  if (cate.serial === data.template_category_id) {
                    return cate
                  }
                })
                if (item.goalCategoryDetail === undefined) {
                  item.goalCategoryDetail = item?.empCategories.find((cate) => {
                    if (cate.serial === data.template_category_id) {
                      return cate
                    }
                  })
                }
                item.goalSerial = data.form_goal_id
                return item
              }
            })
          })
          setMemberList(memberData)
        } else {
          console.log('NO membersData')
        }
      }
      if (goalDetailEdit?.scale_level?.length > 0) {
        let saveScale = [];
        goalDetailEdit?.scale_level?.map((item) => {
          var valueMin = item.value_min;
          var valueMax = item.value_max;
          if (valueMin.indexOf('/') > 0) {
            var splitValue = valueMin.split('/')
            valueMin = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          }
          if (valueMax.indexOf('/') > 0) {
            var splitValue = valueMax.split('/')
            valueMax = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          }
          saveScale.push({ min_value: valueMin, max_value: valueMax, serial: item.serial, level: item.level })
        })
        setScaleLevel(saveScale)
        setScaleLevelCheckbox(true);
      }
      if (goalDetailEdit?.linking_goal?.link_data) {
        if (!isLinking) {
          if (goalDetailEdit?.linking_goal?.linking_goal_type === 'linking_associate') {
            setType('Associated Goal')
          } else {
            setType('Parent Goal')
          }
          if (goalDetailEdit?.linking_goal?.link_data.parent_goal) {
            setValue(goalDetailEdit?.linking_goal?.link_data.parent_goal)
          } else if (goalDetailEdit?.linking_goal?.link_data.link_goal) {
            setValue(goalDetailEdit?.linking_goal?.link_data.link_goal)
          }
          setGoalAlingment(1)
          setOriginalAlignment(1)
          setIsLinking(true)
        }
      }
      if (goalDetailEdit?.kpi_goal_id) {
        setKpiGoalId(goalDetailEdit?.kpi_goal_id)
      }
      if (goalDetailEdit?.kpi_form_id) {
        setKpiFormId(goalDetailEdit?.kpi_form_id)
      }
      if (goalDetailEdit?.evaluator_permission?.evaluator_data?.serial) {
        setEvaluator(goalDetailEdit?.evaluator_permission?.evaluator_data);
      }
      if (goalDetailEdit?.goal_detail?.start_date) {
        setStartDate(goalDetailEdit?.goal_detail?.start_date);
      }
      if (goalDetailEdit?.goal_detail?.end_date) {
        setEndDate(goalDetailEdit?.goal_detail?.end_date);
      }
      if (goalDetailEdit?.cascade_goal?.assigned_members?.length > 0) {
        if (alignmentsData) {
          const originalData = goalDetailEdit?.cascade_goal?.assigned_members;
          const memberData = alignmentsData.filter((item) => {
            return originalData.find((data) => {
              if (data.form_evaluate_id === item.formEvaluateID) {
                item.goalCategoryDetail = categoryOptionData?.find((cate) => {
                  if (cate.serial === data.template_category_id) {
                    return cate
                  }
                })
                if (item.goalCategoryDetail === undefined) {
                  item.goalCategoryDetail = item?.empCategories.find((cate) => {
                    if (cate.serial === data.template_category_id) {
                      return cate
                    }
                  })
                }
                item.goalSerial = data.form_goal_id
                return item
              }
            })
          })
          setAlignmentList(memberData)
          setBackupAlignmentList(memberData)
          setGoalAlingment(2)
          setOriginalAlignment(2)
          setIsCascade(true)
        }
      }
      if (goalDetailEdit?.goal_detail?.specify_unit) {
        setOthers(goalDetailEdit?.goal_detail?.specify_unit)
      }
      if (goalDetailEdit?.goal_detail?.approve_status) {
        setApprovalStatus(goalDetailEdit?.goal_detail?.approve_status)
      }
      if (goalDetailEdit?.goal_type && !state?.sendGoalType) {
        let filterGoal = goalTypeList.filter((item) => item.serial === goalDetailEdit?.goal_type)
        if (filterGoal.length > 0) {
          setGoalType(filterGoal[0].id)
        }
      }
      if (goalDetailEdit?.evaluator_permission?.permission) {
        setPermission(Util.upperFirstWord(goalDetailEdit?.evaluator_permission?.permission))
      }

      // New Data
      if (goalDetailEdit?.measurement) {
        setMeasurement(goalDetailEdit?.measurement)
      }
      if (goalDetailEdit?.more_detail?.length > 0) {
        setMoreDetail(goalDetailEdit?.more_detail)
      }
      if (goalDetailEdit?.remark) {
        setRemark(goalDetailEdit?.remark)
      }


      setIsOwner(goalDetailEdit?.is_owner);
    }
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  const changeAlignment = (val) => {
    if (val != goalAlignment) {
      var stateOption = { ...selectOption };
      setType("")
      if (val == 1) {
        stateOption['type'] = ['Associated Goal', 'Parent Goal'];
        stateOption['value'] = alignmentOption;
        setValue(null)
      } else {
        stateOption['type'] = ['Member', 'Team'];
        stateOption['value'] = [];
        setValue(null)
      }
      setSelectOption(stateOption)
    }
    setGoalAlingment(val)
  }

  const requireField = (text) => {
    return (
      <Grid container direction="row">
        <Grid>
          <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: '500' }}>{text}</Typography>
        </Grid>
        <Grid>
          <Typography style={{ color: '#cc6058', fontSize: '18px', fontWeight: 500 }}>&nbsp;*</Typography>
        </Grid>
      </Grid>)
  }

  const warningMessage = (bool, text) => {
    return (
      bool &&
      <Grid container direction="row">
        <Grid style={{ paddingLeft: '0px' }}>
          <Typography style={{ fontSize: '14px', color: '#CC6058', fontWeight: '500', fontFamily: 'Kanit' }}>{text ? text : t('mygoal.label.fillThisField')}</Typography>
        </Grid>
      </Grid>
    )
  }

  const handleCancelDialog = () => {
    openCancelDialog(false);
    if (id === 'edit') {
      goto('mygoal', state)
    } else {
      goto('mygoal-choose-create', state)
    }
  }

  const handleSaveDialog = () => {
    openSaveDialog(false);
    if (id === 'edit') {
      goto('mygoal', state)
    } else {
      goto('mygoal-choose-create', state)
    }
  }

  const openHandleCancel = (val) => {
    openCancelDialog(val);
  }
  const openHandleSave = (val) => {
    openSaveDialog(val);
  }
  // Varify & Set Data End

  const searchMember = (value) => {
    setTeamSearch(value);
    if (value.length >= 3) {
      setIsSearchMember(true);
      setCheckedMember(checkedAllOfList(memberList, value.toLowerCase()));
    } else {
      setIsSearchMember(false);
    }
  }

  const searchAlignment = (value) => {
    setAlignmentSearch(value);
    if (value.length >= 3) {
      setIsSearchAlignment(true);
      setCheckedAlignment(checkedAllOfList(alignmentList, value.toLowerCase()));
    } else {
      setIsSearchAlignment(false);
    }
  }

  const manageMemberList = (member) => {
    var lists = [...memberList]
    var teamSearchLower = teamSearch.toLowerCase();
    if (lists.findIndex((idx) => idx.formEvaluateID == member.formEvaluateID) >= 0) {
      const index = lists.findIndex((idx) => idx.formEvaluateID == member.formEvaluateID);
      lists = lists.map((item) => {
        if (item.formEvaluateID === member.formEvaluateID) {
          item.deleteFlag = true;
        }
        return item;
      })
      lists.splice(index, 1)
      setCheckedMember(false)
    } else {
      var goalCategoryFind = member?.empCategories?.some((item) => item.serial === goalCategory)
        ? goalCategory
        : member?.empCategories?.some((item) => item.value === categoryWeightValue)
          ? member?.empCategories?.find((item) => item.value === categoryWeightValue).serial
          : null;
      Object.assign(member, { selectGoalCategory: goalCategoryFind })
      lists.push(member)
    }
    var lengthOfMembers = memberOption.filter((item) => (
      item?.code.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.firstName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.lastName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empSubName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empPositionType.toLowerCase().indexOf(teamSearchLower) >= 0
    )
    ).length;
    if (lists.filter((item) => item.formEvaluateID === member.formEvaluateID).length === lengthOfMembers) {
      setCheckedMember(true)
    }

    setMemberList(lists)
  }
  const manageAlignemntList = (member) => {
    var lists = [...alignmentList]
    var alignmentSearchLower = alignmentSearch.toLowerCase();
    if (lists.findIndex((idx) => idx.formEvaluateID == member.formEvaluateID) >= 0) {
      const index = lists.findIndex((idx) => idx.formEvaluateID == member.formEvaluateID);
      lists = lists.map((item) => {
        if (item.formEvaluateID === member.formEvaluateID) {
          item.deleteFlag = true;
        }
        return item;
      })
      lists.splice(index, 1)
      setCheckedAlignment(false)
    } else {
      var goalCategoryFind = member?.empCategories?.some((item) => item.serial === goalCategory)
        ? goalCategory
        : member?.empCategories?.some((item) => item.value === categoryWeightValue)
          ? member?.empCategories?.find((item) => item.value === categoryWeightValue).serial
          : null;
      Object.assign(member, { selectGoalCategory: goalCategoryFind })
      lists.push(member)
    }

    var lengthOfAlignments = memberOption.filter((item) => (
      item?.code.toLowerCase().indexOf(alignmentSearchLower) >= 0 ||
      item?.firstName.toLowerCase().indexOf(alignmentSearchLower) >= 0 ||
      item?.lastName.toLowerCase().indexOf(alignmentSearchLower) >= 0 ||
      item?.empSubName.toLowerCase().indexOf(alignmentSearchLower) >= 0 ||
      item?.empName.toLowerCase().indexOf(alignmentSearchLower) >= 0 ||
      item?.empPositionType.toLowerCase().indexOf(alignmentSearchLower) >= 0
    )
    ).length;
    if (lists.filter((item) => item.formEvaluateID === member.formEvaluateID).length === lengthOfAlignments) {
      setCheckedAlignment(true)
    }
    setAlignmentList(lists)
  }

  const removeMember = (index) => {
    var lists = [...memberList]
    var rmLists = [...removeMembers]
    if (lists[index].goalCategoryDetail?.name) {
      lists[index].deleteFlag = true;
      rmLists.push(lists[index])
    }
    setRemoveMembers(rmLists)
    lists.splice(index, 1)
    setMemberList(lists)
  }

  const removeAlignment = (index) => {
    var lists = [...alignmentList]
    var rmLists = [...removeAlignments]
    if (lists[index].goalCategoryDetail?.name) {
      lists[index].deleteFlag = true;
      rmLists.push(lists[index])
    }
    setRemoveAlignments(rmLists)
    lists.splice(index, 1)
    setAlignmentList(lists)
  }

  const removeAllSelect = () => {
    var rmLists = [...removeMembers]
    memberList.map((item) => {
      if (item?.goalCategoryDetail?.name) {
        item.deleteFlag = true;
        rmLists.push(item)
      }
    })
    setRemoveMembers(rmLists)
    setMemberList([])
  }

  const removeAllAlignment = () => {
    var rmLists = [...removeAlignments]
    alignmentList.map((item) => {
      if (item?.goalCategoryDetail?.name) {
        item.deleteFlag = true;
        rmLists.push(item)
      }
    })
    setRemoveAlignments(rmLists)
    setAlignmentList([])
  }

  const removeAlignmentSelect = () => {
    setAlignmentList(alignmentList.filter((item) => item.goalCategoryDetail))
  }

  const checkedAllOfList = (selectList, search) => {
    const searchLowercase = search.toLowerCase();
    const listOfSearch = memberOption.filter((item) => {
      if (item?.code.toLowerCase().indexOf(searchLowercase) >= 0 ||
        item?.firstName.toLowerCase().indexOf(searchLowercase) >= 0 ||
        item?.lastName.toLowerCase().indexOf(searchLowercase) >= 0 ||
        item?.empSubName.toLowerCase().indexOf(searchLowercase) >= 0 ||
        item?.empName.toLowerCase().indexOf(searchLowercase) >= 0 ||
        item?.empPositionType.toLowerCase().indexOf(searchLowercase) >= 0) {
        return item
      }
    })

    let checked = true;
    if (selectList.length > 0) {
      const searchedList = listOfSearch.filter(object1 => {
        return !selectList.some(object2 => {
          return object1.serial === object2.serial;
        });
      });
      if (searchedList.length !== 0) {
        checked = false;
      }
    } else {
      checked = false
    }

    return checked;
  }

  const unCheckAllOfList = (selectList, search, alignment, otherLists) => {
    const listOfSearch = memberOption.filter((item) => {
      if (item?.code.toLowerCase().indexOf(search) >= 0 ||
        item?.firstName.toLowerCase().indexOf(search) >= 0 ||
        item?.lastName.toLowerCase().indexOf(search) >= 0 ||
        item?.empSubName.toLowerCase().indexOf(search) >= 0 ||
        item?.empName.toLowerCase().indexOf(search) >= 0) {
        return item
      }
    })

    let notUncheck = false;
    if (selectList.length === listOfSearch.length) {
      selectList.filter((item) => {
        var fact = listOfSearch.some((item2) => item.serial === item2.serial)
        if (fact === false) {
          notUncheck = true
        }
      })
    }

    if (notUncheck) {
      return selectList;
    } else {
      if (alignment && approvalStatus === 'approved') {
        return alignmentList.filter((item) => item.goalCategoryDetail)
      } else {
        return otherLists;
      }
    }
  }

  const checkAllMember = () => {
    var lists = []
    var rmLists = [...removeMembers]
    var teamSearchLower = teamSearch.toLowerCase();
    var dataOfSearch = memberOption.filter((item) => (
      item?.code.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.firstName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.lastName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empSubName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empPositionType.toLowerCase().indexOf(teamSearchLower) >= 0
    )
    );
    var dataOfMembers = memberList.filter((item) => (
      item?.code.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.firstName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.lastName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empSubName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
      item?.empPositionType.toLowerCase().indexOf(teamSearchLower) >= 0
    )
    );
    var dataOfOtherSearch = memberList.filter((item) => (
      item?.code.toLowerCase().indexOf(teamSearchLower) < 0 &&
      item?.firstName.toLowerCase().indexOf(teamSearchLower) < 0 &&
      item?.lastName.toLowerCase().indexOf(teamSearchLower) < 0 &&
      item?.empSubName.toLowerCase().indexOf(teamSearchLower) < 0 &&
      item?.empName.toLowerCase().indexOf(teamSearchLower) < 0 &&
      item?.empPositionType.toLowerCase().indexOf(teamSearchLower) < 0
    )
    );
    if (dataOfSearch.length !== (dataOfMembers.length + dataOfOtherSearch.length)) {
      memberList.map((item) => {
        if (item?.code.toLowerCase().indexOf(teamSearchLower) < 0 &&
          item?.firstName.toLowerCase().indexOf(teamSearchLower) < 0 &&
          item?.lastName.toLowerCase().indexOf(teamSearchLower) < 0 &&
          item?.empSubName.toLowerCase().indexOf(teamSearchLower) < 0 &&
          item?.empName.toLowerCase().indexOf(teamSearchLower) < 0 &&
          item?.empPositionType.toLowerCase().indexOf(teamSearchLower) < 0
        ) {
          lists.push(item)
        }
      })
      memberOption.map((item) => {
        if (item?.code.toLowerCase().indexOf(teamSearchLower) >= 0 ||
          item?.firstName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
          item?.lastName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
          item?.empSubName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
          item?.empName.toLowerCase().indexOf(teamSearchLower) >= 0 ||
          item?.empPositionType.toLowerCase().indexOf(teamSearchLower) >= 0
        ) {
          var goalCategoryFind = item?.empCategories?.some((data) => data.serial === goalCategory)
            ? goalCategory
            : item?.empCategories?.some((data) => data.value === categoryWeightValue)
              ? item?.empCategories?.find((data) => data.value === categoryWeightValue).serial
              : null;
          Object.assign(item, { selectGoalCategory: goalCategoryFind })
          lists.push(item)
        }
      })
    }
    if (memberList.length > 0 && (dataOfSearch.length === dataOfMembers.length)) {
      lists = unCheckAllOfList(lists, teamSearchLower, null, dataOfOtherSearch)
      memberList.map((item) => {
        if (item?.goalCategoryDetail?.name) {
          rmLists.push(item)
        }
      })
      setRemoveMembers(rmLists)
    }
    setCheckedMember(!checkedMember)
    setMemberList(lists)
  }
  const checkAllAlignment = () => {
    var lists = []
    var rmLists = [...removeAlignments]
    var alignSearchLower = alignmentSearch.toLowerCase();
    var lengthOfSearch = memberOption.filter((item) => (
      item?.code.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.firstName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.lastName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.empSubName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.empName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.empPositionType.toLowerCase().indexOf(alignSearchLower) >= 0
    )
    );
    var lengthOfAlignments = alignmentList.filter((item) => (
      item?.code.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.firstName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.lastName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.empSubName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.empName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
      item?.empPositionType.toLowerCase().indexOf(alignSearchLower) >= 0
    )
    );
    var dataOfOtherSearch = memberList.filter((item) => (
      item?.code.toLowerCase().indexOf(alignSearchLower) < 0 &&
      item?.firstName.toLowerCase().indexOf(alignSearchLower) < 0 &&
      item?.lastName.toLowerCase().indexOf(alignSearchLower) < 0 &&
      item?.empSubName.toLowerCase().indexOf(alignSearchLower) < 0 &&
      item?.empName.toLowerCase().indexOf(alignSearchLower) < 0 &&
      item?.empPositionType.toLowerCase().indexOf(alignSearchLower) < 0
    )
    );
    if (lengthOfSearch.length !== (lengthOfAlignments.length + dataOfOtherSearch.length)) {
      alignmentList.map((item) => {
        if (item?.code.toLowerCase().indexOf(alignSearchLower) < 0 &&
          item?.firstName.toLowerCase().indexOf(alignSearchLower) < 0 &&
          item?.lastName.toLowerCase().indexOf(alignSearchLower) < 0 &&
          item?.empSubName.toLowerCase().indexOf(alignSearchLower) < 0 &&
          item?.empName.toLowerCase().indexOf(alignSearchLower) < 0 &&
          item?.empPositionType.toLowerCase().indexOf(alignSearchLower) < 0
        ) {
          lists.push(item)
        }
      })
      memberOption.map((item) => {
        if (item?.code.toLowerCase().indexOf(alignSearchLower) >= 0 ||
          item?.firstName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
          item?.lastName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
          item?.empSubName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
          item?.empName.toLowerCase().indexOf(alignSearchLower) >= 0 ||
          item?.empPositionType.toLowerCase().indexOf(alignSearchLower) >= 0
        ) {
          var goalCategoryFind = item?.empCategories?.some((data) => data.serial === goalCategory)
            ? goalCategory
            : item?.empCategories?.some((data) => data.value === categoryWeightValue)
              ? item?.empCategories?.find((data) => data.value === categoryWeightValue).serial
              : null;
          Object.assign(item, { selectGoalCategory: goalCategoryFind })
          lists.push(item)
        }
      })
    }
    if (alignmentList.length > 0 && (lengthOfSearch.length === lengthOfAlignments.length)) {
      lists = unCheckAllOfList(lists, alignSearchLower, 'alignment', dataOfOtherSearch)
      if (approvalStatus === 'new') {
        alignmentList.map((item) => {
          if (item?.goalCategoryDetail?.name) {
            rmLists.push(item)
          }
        })
      }
      setRemoveAlignments(rmLists)
    }
    setCheckedAlignment(!checkedAlignment)
    setAlignmentList(lists)
  }

  const checkScaleLevel = () => {
    setScaleLevelCheckbox(!scaleLevelCheckbox)
  }

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  // Function End

  // Variable Start
  const [verifyField, setVerifyField] = React.useState({})
  const [goalType, setGoalType] = React.useState()
  const [goalCategory, setCategory] = React.useState(null)
  const [goalName, setGoalName] = React.useState(null)
  const [measurement, setMeasurement] = React.useState(null)
  const [remark, setRemark] = React.useState(null)
  const [goalDetail, setGoalDetail] = React.useState(null)
  const [startDate, setStartDate] = React.useState(Util.formatDate(new Date()))
  const [endDate, setEndDate] = React.useState(Util.formatDate(Util.subStractDate(new Date(), "add", 1)))
  const [targetValue, setTargetValue] = React.useState(null)
  const [weight, setWeight] = React.useState(0)
  const [others, setOthers] = React.useState(null)
  const [approvalStatus, setApprovalStatus] = React.useState(null)
  const [evaluator, setEvaluator] = React.useState(null)
  const [goalMetric, setGoalMetric] = React.useState(null)
  const [unit, setUnit] = React.useState(null)
  const [condition, setCondition] = React.useState(null)
  const [memberType, setMemberType] = React.useState(null)
  const [member, setMember] = React.useState([])
  const [permission, setPermission] = React.useState("Private")
  const [scaleLevel, setScaleLevel] = React.useState([
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
  ])
  const [categoryWeight, setCategoryWeight] = React.useState(0)
  const [canCascading, setCancascading] = React.useState(false)
  const [scaleCondition, setScaleCondition] = React.useState([
    { min_value: '1', max_value: '20' },
    { min_value: '21', max_value: '40' },
    { min_value: '41', max_value: '60' },
    { min_value: '61', max_value: '80' },
    { min_value: '81', max_value: '100' },
  ])
  const [selectOption, setSelectOption] = React.useState({
    goalMetric: [],
    goalType: [],
    condition: [],
    unit: [],
    evaluator: [],
    member: [],
    memberType: [],
    permission: [],
  })
  const [respOption, setRespOption] = React.useState(null)
  const [goalCategoryOptions, setGoalCategoryOptions] = React.useState([])
  const [memberTeamOption, setMemberTeamOption] = React.useState([])
  const [memberOption, setMemberOption] = React.useState([])
  const [orderScale, setOrderScale] = React.useState('asc');
  const [isCancelDialogOpen, openCancelDialog] = React.useState(false);
  const [isSaveDialogOpen, openSaveDialog] = React.useState(false);
  const [isSuccessEditOpen, openSuccessEditOpen] = React.useState(false);
  const [isConfirmEditOpen, openConfirmEditOpen] = React.useState(false);
  const [evaluatorSerial, setEvaluatorSerial] = React.useState(null);
  const [isSearchMember, setIsSearchMember] = React.useState(false);
  const [isSearchAlignment, setIsSearchAlignment] = React.useState(false);
  const [teamSearch, setTeamSearch] = React.useState(null);
  const [alignmentSearch, setAlignmentSearch] = React.useState(null);
  const [goalAlignment, setGoalAlingment] = React.useState(0)
  const [isLinking, setIsLinking] = React.useState(false)
  const [isCascade, setIsCascade] = React.useState(false)
  const [type, setType] = React.useState("")
  const [value, setValue] = React.useState(null);
  const [alignmentOption, setAlignmentOption] = React.useState([])
  const [memberList, setMemberList] = React.useState([])
  const [alignmentList, setAlignmentList] = React.useState([])
  const [backupAlignmentList, setBackupAlignmentList] = React.useState([])
  const [scaleLevelCheckbox, setScaleLevelCheckbox] = React.useState(false)
  const [checkedMember, setCheckedMember] = React.useState(false)
  const [checkedAlignment, setCheckedAlignment] = React.useState(false)
  const [goalTemplateSerial, setGoalTemplateSerial] = React.useState("")
  const [kpiFormId, setKpiFormId] = React.useState(null)
  const [kpiGoalId, setKpiGoalId] = React.useState(null)
  const [editFirstCome, setEditFirstCome] = React.useState(true)
  const [fetchFirstCome, setFetchFirstCome] = React.useState(true)
  const [respFirstCome, setRespFirstCome] = React.useState(true)
  const [backupCategory, setBackupCategory] = React.useState(null)
  const [removeMembers, setRemoveMembers] = React.useState([])
  const [removeAlignments, setRemoveAlignments] = React.useState([])
  const [originalAlignment, setOriginalAlignment] = React.useState(null)
  const [categoryWeightValue, setCategoryWeightValue] = React.useState(null)
  const [isOwner, setIsOwner] = React.useState(true)
  const [changing, setChanging] = React.useState(false)
  const [cycleId, setCycleId] = React.useState("")
  const [goalMasterSerial, setGoalMasterSerial] = React.useState(null)
  const [moreDetail, setMoreDetail] = React.useState([])

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState("");
  const headerMember = [
    { field: 'code', headerName: t('mygoal.etc.employee'), width: 50 },
    { field: 'firstName', headerName: t('mygoal.etc.name'), width: 100 },
    { field: 'empSubName', headerName: t('mygoal.etc.position'), width: 100 },
    { field: 'empName', headerName: t('mygoal.etc.team'), width: 100 },
    { field: 'template', headerName: t('admin.inputForm.goalTemplate'), width: 100 },
    { field: 'selectEmpCategories', headerName: 'Goal Category', width: 100 },
    { field: '', headerName: '', width: 50 },
  ]

  // Variable End



  const getTitle = () => {
    let title = t('mygoal.page.mygoal')

    if (state.isEvaluator && state.owner?.firstname) {
      title = state.owner.firstname + ' ' + state.owner.lastname
      title += '\'s ' + t('label.goal')
    }

    return title
  }

  useEffect(async () => {
    if (fetchFirstCome) {
      var stateOption = { ...selectOption };
      stateOption['memberType'] = ['Team', 'Member'];
      stateOption['permission'] = [
        { value: 'Private', descriptionEn: 'Private', descriptionTh: 'ส่วนตัว' },
        { value: 'Line', descriptionEn: 'Line', descriptionTh: 'สายงาน' },
        { value: 'Team', descriptionEn: 'Team', descriptionTh: 'ทีม' }
      ];
      var memberOptionData = [];
      var alignmentOptionData = [];
      var categoryOptionData = [];
      var goalTypeList = [];

      await dispatch(getDropdownMetric())
        .then(resp => {
          if (resp.data.length > 0 || Object.keys(resp.data).length > 0) {
            var metric = resp.data.metric.map((item) => {
              return {
                ...item,
                code: item.code.charAt(0).toUpperCase() + item.code.slice(1),
              }
            })
            stateOption['goalMetric'] = metric;
            var targetCon = resp.data.metric.filter((item) => item.options !== null && item.code === 'value')
            stateOption['condition'] = targetCon[0].options.target_condition;
            setRespOption(resp.data.metric)
          }
        })

      await dispatch(getDropdownUnit())
        .then(resp => {
          if (resp.data.length > 0 || Object.keys(resp.data).length > 0) {
            stateOption['unit'] = resp.data.unit;
            stateOption['unitOption'] = resp.data.unit;
            if (unit != null) {
              const unitList = resp?.data?.unit?.find((item) => item.serial = unit)
              setUnit(unitList)
            }
          }
        })

      await dispatch(getMemberList(state?.serial)).then(resp => {
        let memberList = resp.data.goalMemberList.filter(item => { return item.formStatus === 'draft' })

        memberOptionData = resp.data.goalMemberList// resp.data.goalMemberList.map((item) => { return { ...item } });
        alignmentOptionData = memberList// resp.data.goalMemberList.map((item) => { return { ...item } });
        setMemberOption(memberList);
      })

      // await dispatch(getMemberTeamList())
      //   .then(resp => {
      //     setMemberTeamOption(resp.data.goalMemberTeamList);
      //   })

      await dispatch(getEvaluatorList())
        .then(resp => {
          stateOption['evaluator'] = resp.data.goalEvaluatorList;
        })

      await dispatch(getGoalType(state.serial))
        .then(resp => {
          stateOption['goalType'] = resp.data.goalTypeMap;
          //setGoalTemplateSerial(resp.data.goalTemplateSerial)

          if (resp.data.goalTemplateSerial) setGoalTemplateSerial(resp.data.goalTemplateSerial)

          if (id === 'quick') {
            const personal = resp.data.goalTypeMap.filter((item) => item.code === 'personal')[0]
            setGoalType(personal.serial)
          }
          goalTypeList = resp.data.goalTypeMap

          //console.log('goalTypeList', goalTypeList)
        })

      await dispatch(getGroupCategory(state.serial))
        .then(resp => {
          categoryOptionData = resp.data.goalCategory;
          setGoalCategoryOptions(resp.data.goalCategory);
          if (state.defaultCategory) {
            const serial = categoryOptionData.find((item) => (item.code === state.defaultCategory)).serial
            const categoryList = categoryOptionData.find((item) => (item.code === state.defaultCategory))
            chooseCategory(serial, categoryList)
          }
        })

      var scaleObject = []
      await dispatch(getScaleLevel(state.serial))
        .then(resp => {
          resp.data.goalScaleLevel?.map((item, key) => {
            scaleObject.push({ min_value: null, max_value: null, serial: item.serial, level: item.level })
          })
          setScaleLevel(scaleObject)
        })


      await dispatch(getCustomForm(state.serial))
        .then(resp => {
          if (resp.data.length > 0) {
            let data = resp.data;
            if (data?.options && data?.options?.default !== undefined) {
              data.value = data?.options?.default
            }
            setMoreDetail(data);
          }
          // stateOption['type'] = ['Associated Goal','Parent Goal'];
          // stateOption['value'] = resp.data.list_goal;
        })

      setFetchFirstCome(false);
      setSelectOption(stateOption);

      if (id === 'edit' && editFirstCome && (memberOptionData.length > 0 || alignmentOptionData.length > 0 || categoryOptionData.length > 0)) {
        await dispatch(getGoalForEdit(state.goalSerial))
          .then(async resp => {
            if (resp?.data?.goal_detail?.cycle_id) setCycleId(resp?.data?.goal_detail?.cycle_id)

            await dispatch(getAlignmentList(resp?.data?.goal_detail?.cycle_id))
              .then(resp => {
                stateOption['type'] = ['Associated Goal', 'Parent Goal'];
                stateOption['value'] = resp.data.list_goal;
                setAlignmentOption(resp.data.list_goal)
              })

            setValueFromForEdit(resp?.data?.goal_detail, memberOptionData, alignmentOptionData, categoryOptionData, goalTypeList)
            setEditFirstCome(false)
          })
      }
      else {

        await dispatch(getAlignmentList(state.cycle_id))
          .then(resp => {
            stateOption['type'] = ['Associated Goal', 'Parent Goal'];
            stateOption['value'] = resp.data.list_goal;
            setAlignmentOption(resp.data.list_goal)
          })
      }
    }
  }, []);

  useEffect(() => {
    if (respFirstCome) {
      setValueFromAnotherPage();
      setRespFirstCome(false)
    }
  }, [respOption])

  useEffect(() => {
    if (goalCategoryOptions.length === 1) chooseCategory(goalCategoryOptions[0].serial, goalCategoryOptions[0])
  }, [goalCategoryOptions])

  return (
    <>
      <Helmet>
        <title>{getTitle()} | GOAL </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => changing ? openCancelDialog(true) : goto('home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => changing ? openCancelDialog(true) : goto('mygoal', state)}>
                {` ${getTitle()}`}
              </span> /
              <span style={styles.end} >
                {id === 'edit' ? ` ${t('mygoal.page.editGoal')}` : ` ${t('mygoal.page.createGoal')}`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography variant="h1" fontSize={32} lineHeight="39.6px" fontWeight="600" color="#404349">
                {id == 'quick'
                  ? t('mygoal.type.quick')
                  : id === 'edit'
                    ? t('mygoal.type.edit')
                    : t('mygoal.type.detail')
                }
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16} color="#404349" fontWeight={400}>
                {id == 'quick'
                  ? t('mygoal.type.quickDesc')
                  : t('mygoal.type.detailDesc')
                }
              </Typography>
            </Grid>
          </Grid>
          {id != 'quick' &&
            <Box ref={goalTypeRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                    {t("mygoal.label.labelGoalType")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ paddingLeft: '35px' }}>
                {selectOption?.goalType?.map((item, idx) => {
                  return (
                    (item.serial == goalType || item.id == goalType) &&
                    <Grid lg={2} xs={12} key={idx} item>
                      <Card style={(item.serial == goalType || item.id == goalType) ? { border: '1px solid #5DA196', cursor: 'pointer', cursor: 'pointer', width: '150px', height: '150px' } : { border: null, width: '150px', height: '150px' }} onClick={() => { chooseLibrary(item) }}>
                        <CardContent style={{ padding: 0 }}>
                          <Grid item lg={12} xs={12} container textAlign="center">
                            <Grid item>
                              <Radio name="radio" value="1" checked={(item.serial == goalType || item.id == goalType)} size="small" />
                            </Grid>
                            <Grid item lg={12}>
                              {item.code === 'personal' ? <PersonalActive /> : item.code === 'team' ? <TeamActive /> : <CompActive />}
                            </Grid>
                            <Grid item lg={12}>
                              <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={'#404349'}>
                                {item.description}
                              </Typography>
                            </Grid>
                            <Grid item lg={12}>
                              <Typography fontSize={13} variant="label" fontWeight={400} color={'#A3A3A3'}>
                                {item.id === 'personal' ? t('mygoal.label.personalDescShort1') : item.code === 'team' ? t('mygoal.label.teamDescShort1') : t('mygoal.label.corpDescShort1')}
                              </Typography>
                            </Grid>
                            <Grid item lg={12}>
                              <Typography fontSize={13} variant="label" fontWeight={400} color={'#A3A3A3'}>
                                {item.id === 'personal' ? t('mygoal.label.personalDescShort2') : item.id === 'team' ? t('mygoal.label.teamDescShort2') : t('mygoal.label.corpDescShort2')}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
          }
          <Box ref={goalDetailRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} lineHeight="39.6px" fontWeight="600" color="#404349">
                  {t("mygoal.label.goalDetail")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} ml={2} pr={5}>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.goalName"))}
                </Typography>
              </Grid>
              <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField error={verifyField.name} onChange={(e) => changeValue(e.target.value, 'name')}
                  id="outlined-basic" placeholder={t('mygoal.placeholder.name')} value={goalName} variant="outlined"
                  required fullWidth size="small"
                  style={{ WebkitTextFillColor: !goalName ? '#A3A3A3' : '#404349', fontWeight: !goalName ? '300' : '400', fontSize: '16px', borderColor: verifyField.name ? '#CC6058' : '#e1e1e1', paddingTop: '7px' }}
                  disabled={!isOwner}
                  sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                />
                {(verifyField.name && !goalName) &&
                  warningMessage(verifyField.name)
                }
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.goalDetail"))}
                </Typography>
              </Grid>
              <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField
                  multiline
                  fullWidth
                  rows={4}
                  placeholder={t('mygoal.placeholder.description')}
                  style={{
                    opacity: !goalDetail === null ? 0.5 : 1, width: '100%',
                    font: 'inherit', fontFamily: 'Kanit', resize: 'none', outlineColor: '#5DA196', borderRadius: '4px',
                    WebkitTextFillColor: !goalDetail ? '#A3A3A3' : '#404349', fontWeight: !goalDetail ? '300' : '400', fontSize: '16px',
                    borderColor: verifyField.detail ? '#CC6058' : '#e1e1e1', backgroundColor: !isOwner ? '#F3F3F3!important' : ''
                  }}
                  value={goalDetail}
                  error={verifyField.detail && !goalDetail}
                  disabled={!isOwner}
                  InputProps={!isOwner ? { className: classes.disabled } : {}}
                  onChange={(e) => changeValue(e.target.value, 'detail')}
                />
                {(verifyField.detail && !goalDetail) &&
                  warningMessage(verifyField.detail)
                }
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.measurement"))}
                </Typography>
              </Grid>
              <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField
                  multiline
                  rows={2}
                  error={verifyField.measurement} onChange={(e) => changeValue(e.target.value, 'measurement')}
                  id="outlined-basic" placeholder={t('mygoal.placeholder.measurement')} value={measurement} variant="outlined"
                  required fullWidth size="small"
                  style={{ WebkitTextFillColor: !measurement ? '#A3A3A3' : '#404349', fontWeight: !measurement ? '300' : '400', fontSize: '16px', borderColor: verifyField.measurement ? '#CC6058' : '#e1e1e1', paddingTop: '7px', backgroundColor: !isOwner ? '#F3F3F3!important' : '' }}
                  sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                  InputProps={!isOwner ? { className: classes.disabled } : {}}
                  disabled={!isOwner}
                />
                {(verifyField.measurement && !measurement) &&
                  warningMessage(verifyField.measurement)
                }
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.startDate"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.endDate"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    format="dd/MM/yyyy"
                    value={startDate}
                    disabled={!isOwner}
                    onChange={(newValue) => {
                      if (newValue) {
                        setStartDate(Util.formatDate(newValue));
                      } else {
                        setStartDate(null)
                      }
                    }}
                    style={{ color: '#404349', fontWeight: !startDate ? '300' : '400', fontSize: '16px', borderColor: verifyField.startDate ? '#CC6058' : '#e1e1e1' }}
                    inputProps={{
                      placeholder: t('mygoal.placeholder.startDate'), sx: {
                        "&::placeholder": {
                          color: '#A3A3A3'
                        }
                      }
                    }}
                    renderInput={(params) => <TextField {...params}
                      fullWidth
                      size="small"
                      sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                      error={verifyField.startDate && !startDate}
                    />
                    }
                  />
                </LocalizationProvider>
                {(verifyField.startDate && !startDate) &&
                  warningMessage(verifyField.startDate)
                }
              </Grid>
              <Grid lg={6} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    format="dd/MM/yyyy"
                    value={endDate}
                    disabled={!isOwner}
                    classes={!isOwner ? { select: classes.disabled } : {}}
                    minDate={addDate(startDate, 0)}
                    onChange={(newValue) => {
                      if (newValue) {
                        setEndDate(Util.formatDate(newValue));
                        if (goalMetric == 'Date') {
                          setTargetValue(dayjs(newValue).format('DD/MM/YYYY'))
                        }
                      } else {
                        setEndDate(null)
                        if (goalMetric == 'Date') {
                          setTargetValue(null)
                        }
                      }
                    }}
                    style={{ color: '#404349', fontWeight: endDate === null ? '300' : '400', fontSize: '16px', borderColor: verifyField.endDate ? '#CC6058' : '#e1e1e1' }}
                    inputProps={{
                      placeholder: t('mygoal.placeholder.endDate'), sx: {
                        "&::placeholder": {
                          color: '#A3A3A3',
                          fontWeight: 300,
                          fontFamily: 'Kanit'
                        }
                      }
                    }}
                    renderInput={(params) => <TextField {...params}
                      fullWidth
                      sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : { input: { color: '#404349' } }}
                      size="small"
                      error={verifyField.endDate}
                    />
                    }
                  />
                </LocalizationProvider>
                {(verifyField.endDate && endDate === null) &&
                  warningMessage(verifyField.endDate)
                }
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.labelGoalMetric"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.targetCondition"))}
                </Typography>
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <FormControl sx={{ minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.goalMetric}
                    labelId="metric"
                    id="metric"
                    input={<OutlinedInput size="small" />}
                    value={goalMetric}
                    onChange={(val) => { handleChange(val.target.value, 'metric') }}
                    style={{ borderColor: verifyField.goalMetric ? '#CC6058' : '#e1e1e1', }}
                    disabled={!isOwner}
                    classes={!isOwner ? { select: classes.disabled } : {}}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <Typography style={{ color: goalMetric === null ? '#A3A3A370' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: goalMetric === null ? '300' : '400', fontSize: '16px' }}>
                          {t('mygoal.placeholder.metric')}
                        </Typography>;
                      } else {
                        return selectOption?.goalMetric?.find((item) => item.code === selected).description
                      }
                    }}
                  >
                    {/* <MenuItem disabled value="">
                      <Typography style={{color: goalMetric === null ? '#A3A3A3' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: goalMetric === null ? '300' : '400', fontSize: '16px'}}>
                        {t('mygoal.placeholder.metric')}
                        </Typography>
                    </MenuItem> */}
                    {selectOption?.goalMetric?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.code}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.description}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
                {(verifyField.goalMetric && goalMetric === null) &&
                  warningMessage(verifyField.goalMetric)
                }
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <FormControl sx={{ minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.condition}
                    disabled={goalMetric != 'Value' || !isOwner}
                    classes={goalMetric != 'Value' || !isOwner ? { select: classes.disabled } : {}}
                    labelId="condition"
                    id="condition"
                    value={condition}
                    style={{ borderColor: verifyField.condition ? '#CC6058' : '#e1e1e1' }}
                    onChange={(val) => { handleChange(val.target.value, 'condition') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <Typography style={{ color: condition === null ? '#A3A3A370' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: condition === null ? '300' : '400', fontSize: '16px' }}>{goalMetric != 'Value' ? '' : t('mygoal.placeholder.targetCondition')}</Typography>;
                      } else {
                        return selected
                      }
                    }}
                  >
                    {/* <MenuItem disabled value="">
                      <Typography style={{color: condition === null ? '#A3A3A3' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: condition === null ? '300' : '400', fontSize: '16px'}}>{t('mygoal.placeholder.targetCondition')}</Typography>
                    </MenuItem> */}
                    {selectOption?.condition?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.label}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.label}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
                {(verifyField.condition && condition === null) &&
                  warningMessage(verifyField.condition)
                }
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.unit"))}
                </Typography>
              </Grid>
              <Grid lg={4} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.labelTargetValue"))}
                </Typography>
              </Grid>
              <Grid lg={2} xs={12} item style={{ textAlign: 'right', alignItems: 'flex-end' }}>
                {valueCondition()}
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <FormControl sx={{ minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.unit}
                    labelId="unit"
                    id="unit"
                    value={unit}
                    disabled={goalMetric != 'Value' || !isOwner}
                    classes={goalMetric != 'Value' || !isOwner ? { select: classes.disabled } : {}}
                    onChange={(val) => { handleChange(val.target.value, 'unit') }}
                    input={<OutlinedInput size="small" />}
                    style={{ borderColor: verifyField.unit ? '#CC6058' : '#e1e1e1' }}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <Typography style={{ color: !unit ? '#A3A3A370' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: !unit ? '300' : '400', fontSize: '16px' }}>{goalMetric != 'Value' ? '' : t('mygoal.placeholder.targetUnit')}</Typography>;
                      } else {
                        return selectOption?.unit?.find((item) => (item.serial === selected || item.description === selected)).description
                      }
                    }}
                  >
                    {/* <MenuItem disabled value="">
                      <Typography style={{color: !unit ? '#A3A3A3' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: !unit ? '300' : '400', fontSize: '16px'}}>{t('mygoal.placeholder.targetUnit')}</Typography>
                    </MenuItem> */}
                    {selectOption?.unit?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.code === 'custom' ? 'Custom' : option.serial}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.description}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
                {(verifyField.unit && !unit) &&
                  warningMessage(verifyField.unit)
                }
              </Grid>
              <Grid lg={6} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                <TextField
                  error={verifyField.targetValue}
                  disabled={goalMetric != 'Value' || !isOwner}
                  id="targetValue"
                  placeholder={goalMetric === 'Value' ? t('mygoal.placeholder.targetValue') : ''}
                  variant="outlined"
                  value={targetValue}
                  onChange={(e) => changeValue(e.target.value, 'targetValue')}
                  required
                  fullWidth
                  size="small"
                  sx={{ input: { stroke: 'none', color: '#404349 !important', fontSize: '16px !important', fontWeight: '400', fontFamily: 'kanit', backgroundColor: goalMetric === 'Value' ? 'transparent' : '#FAFAFA !important' } }}
                  style={{ color: '#404349', fontWeight: !targetValue ? '300' : '400', fontSize: '16px', borderColor: verifyField.targetValue ? '#CC6058' : '#e1e1e1' }}
                  inputProps={{
                    sx: {
                      "&::placeholder": {
                        color: '#A3A3A3',
                        fontWeight: 300,
                        fontFamily: 'Kanit'
                      }
                    }
                  }}
                />
                {(verifyField.targetValue && !targetValue) &&
                  warningMessage(verifyField.targetValue)
                }
              </Grid>
            </Grid>
            {(unit == 'Custom' || unit == 'custom') &&
              <Grid lg={6} container direction="row" style={{ paddingTop: '10px', paddingBottom: '9px', paddingRight: '10px', paddingLeft: '35px' }}>
                <Grid item lg={2.5} alignSelf="center">
                  <Typography style={{ fontSize: '14px !important' }}>
                    {requireField(t('mygoal.label.specify'))}
                  </Typography>
                </Grid>
                <Grid item lg={9.5}>
                  <TextField id="others" error={verifyField.others} placeholder="Specify how you measure the activity" variant="outlined" value={others} onChange={(e) => changeValue(e.target.value, 'others')} required fullWidth size="small" disabled={!isOwner}
                    style={{ marginLeft: 10, marginTop: 8, WebkitTextFillColor: others === null ? '#A3A3A370' : '#404349', fontWeight: others === null ? '300' : '400', fontSize: '16px' }} />
                  <Typography style={{ marginLeft: '10px' }}>
                    {(verifyField.others && !others) &&
                      warningMessage(verifyField.others)
                    }
                  </Typography>
                </Grid>
              </Grid>
            }
          </Box>
          {moreDetail.length > 0 &&
            <Box ref={moreDetailRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
              <MoreDetailCustom moreDetail={moreDetail} changeMoreDetail={changeMoreDetail} warningMessage={warningMessage} verifyField={verifyField} isOwner={isOwner} />
            </Box>
          }
          {(goalMetric != null && goalMetric != 'Accomplishment' && id != 'quick') &&
            <Box ref={goalScaleRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container direction="row">
                <Grid item mb={2}>
                  <Checkbox {...label} mb={2} onClick={() => isOwner ? checkScaleLevel() : {}} disabled={!isOwner} value={scaleLevelCheckbox} checked={scaleLevelCheckbox} />
                </Grid>
                <Grid item mb={2}>
                  <Typography fontSize={16} fontWeight={400} color="#404349">
                    {t("mygoal.label.setScaleLevel")}
                  </Typography>
                  <Typography fontSize={16} fontWeight={400} color="#A3A3A3">
                    {t("mygoal.label.scaleLevelSub")}
                  </Typography>
                </Grid>
              </Grid>
              {scaleLevelCheckbox === true &&
                <Grid container ml={5} pr={6}>
                  <Grid item>
                    <Typography fontSize={22} fontWeight={600}>
                      {requireField(t("mygoal.label.scaleLevel"))}
                    </Typography>
                  </Grid>
                  <Grid ml={1} container spacing={2} style={{ border: '1px solid #DADADA', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '13px', borderRadius: '10px' }} mt={3}>
                    <Grid md={2} item textAlign="center">
                      <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'}>
                        {t("mygoal.label.level")}
                      </Typography>
                    </Grid>
                    <Grid md={2} item></Grid>
                    <Grid md={3} item textAlign="center">
                      <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'}>
                        {t("mygoal.label.actualMin")}
                      </Typography>
                    </Grid>
                    <Grid md={1} item></Grid>
                    <Grid md={3} item textAlign="center">
                      <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'}>
                        {t("mygoal.label.actualMax")}
                      </Typography>
                    </Grid>

                    {scaleLevel.map((scale, idx) => {
                      return (
                        <Grid container key={idx}>
                          <Grid md={12} item mt={1.5} mb={1.5}>
                            <Divider />
                          </Grid>
                          <Grid md={2} item textAlign="center">
                            <Typography variant="label" style={{ fontWeight: 400, fontSize: '18px', color: '#404349' }}>
                              {scale.level}
                            </Typography>
                          </Grid>
                          <Grid md={2} item></Grid>
                          <Grid md={3} item>
                            {goalMetric == 'Date'
                              ?
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                  error={(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) || verifyField.scaleLevel}
                                  format="dd/MM/yyyy"
                                  value={scale.min_value}
                                  onChange={(value) => changeScaleLevel(value, `scaleMin`, `${idx}`)}
                                  style={{ color: '#404349', fontWeight: endDate === null ? '300' : '400', fontSize: '16px' }}
                                  inputProps={{
                                    placeholder: t('mygoal.placeholder.startDate'), sx: {
                                      "&::placeholder": {
                                        color: '#A3A3A3'
                                      }
                                    }
                                  }}
                                  disabled={!isOwner}
                                  classes={!isOwner ? { select: classes.disabled } : {}}
                                  renderInput={(params) => <TextField {...params}
                                    fullWidth
                                    size="small"
                                    error={(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) || verifyField.scaleLevel}
                                  />
                                  }
                                />
                              </LocalizationProvider>
                              :
                              <TextField id="outlined-basic" value={scale?.min_value} onChange={(e) => changeScaleLevel(e.target.value, `scaleMin`, `${idx}`)}
                                error={(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) || verifyField.scaleLevel}
                                placeholder={scaleCondition[idx]?.min_value ? `${t('mygoal.etc.eg')} ${scaleCondition[idx]?.min_value}` : t('mygoal.placeholder.scaleLevel')} variant="outlined" required fullWidth size="small"
                                style={{ WebkitTextFillColor: scale?.min_value === null ? '#A3A3A3A70' : '#404349', fontWeight: '300', borderColor: scale?.min_value ? '#CED4DA' : '#FAFAFA', borderRadius: '4px' }}
                                disabled={!isOwner}
                                InputProps={{
                                  classes: {
                                    notchedOutline: styles.notchedOutline
                                  },
                                  className: !isOwner ? classes.disabled : null
                                }}
                              />
                            }
                            {(verifyField.scaleLevelEmpty && (scale.min_value === null || !scale.min_value)) &&
                              warningMessage(verifyField.scaleLevelEmpty)
                            }
                            {(verifyField.scaleLevel) &&
                              warningMessage(verifyField.scaleLevel, t('mygoal.label.overlap'))
                            }
                          </Grid>
                          <Grid md={1} item></Grid>
                          <Grid md={3} item>
                            {goalMetric == 'Date'
                              ?
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                  format="dd/MM/yyyy"
                                  value={scale.max_value}
                                  error={(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) || verifyField.scaleLevel}
                                  onChange={(value) => changeScaleLevel(value, `scaleMax`, `${idx}`)}
                                  style={{ color: '#404349', fontWeight: scale.max_value === null ? '300' : '400', fontSize: '16px' }}
                                  inputProps={{
                                    placeholder: t('mygoal.placeholder.endDate'), sx: {
                                      "&::placeholder": {
                                        color: '#A3A3A3'
                                      }
                                    }
                                  }}
                                  disabled={!isOwner}
                                  classes={!isOwner ? { select: classes.disabled } : {}}
                                  renderInput={(params) => <TextField {...params}
                                    fullWidth
                                    size="small"
                                    error={(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) || verifyField.scaleLevel}
                                  />
                                  }
                                />
                              </LocalizationProvider>
                              :
                              <TextField id="outlined-basic" value={scale?.max_value} onChange={(e) => changeScaleLevel(e.target.value, `scaleMax`, `${idx}`)}
                                error={(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) || verifyField.scaleLevel}
                                placeholder={scaleCondition[idx]?.max_value ? `${t('mygoal.etc.eg')} ${scaleCondition[idx]?.max_value}` : t('mygoal.placeholder.scaleLevel')} variant="outlined" required fullWidth size="small"
                                style={{ WebkitTextFillColor: scale?.max_value === null ? '#A3A3A3A70' : '#404349', fontWeight: '300', borderColor: scale?.min_value ? '#CC6058' : '#e1e1e1', borderRadius: '4px' }}
                                disabled={!isOwner}
                                InputProps={{
                                  classes: {
                                    notchedOutline: styles.notchedOutline
                                  },
                                  className: !isOwner ? classes.disabled : null
                                }}
                              />
                            }
                            {(verifyField.scaleLevelEmpty && (scale.max_value === null || !scale.max_value)) &&
                              warningMessage(verifyField.scaleLevelEmpty)
                            }
                            {(verifyField.scaleLevel) &&
                              warningMessage(verifyField.scaleLevel, t('mygoal.label.overlap'))
                            }
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Grid>
              }
            </Box>
          }
          <Box ref={goalWeightRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 30 }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                  {t("mygoal.label.goalCategory")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item style={{ marginLeft: '30px' }} lg={12}>
                <Grid container spacing={2}>
                  {goalCategoryOptions?.map((categories, idx) => {
                    return (
                      <Grid lg={1.5} xs={12} key={idx} item>
                        <Card style={goalCategory === categories.serial ? { border: '1px solid #5DA196', cursor: 'pointer', height: '150px', width: '150px', borderRadius: 10, borderColor: (verifyField.goalCategory && !goalCategory) ? '#CC6058' : '#5DA196' } : { border: '1px solid #DADADA', cursor: 'pointer', height: '150px', width: '150px', borderRadius: 10, borderColor: (verifyField.goalCategory && !goalCategory) ? '#CC6058' : '#DADADA' }} onClick={() => chooseCategory(categories.serial, categories)}>
                          <CardContent style={{ padding: 0 }}>
                            <Grid item lg={12} xs={12} container textAlign="center">
                              <Grid item>
                                <Radio name="radio" value="1" checked={goalCategory === categories.serial} size="small" />
                              </Grid>
                              <Grid item lg={12}>
                                <Icon style={{ color: categories.color, fontSize: 50 }}>{categories.icon}</Icon>
                              </Grid>
                              <Grid item lg={12} mt={1}>
                                <BootstrapTooltip
                                  placement="right"
                                  arrow
                                  title={categories.name}
                                  style={{ marginLeft: '5px' }}
                                >
                                  <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349"
                                    sx={{
                                      display: '-webkit-box',
                                      overflow: 'hidden',
                                      WebkitBoxOrient: 'vertical',
                                      WebkitLineClamp: 2
                                    }}
                                  >
                                    {categories.name}
                                  </Typography>
                                </BootstrapTooltip>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    )
                  })}
                </Grid>
                {(verifyField.goalCategory && !goalCategory) &&
                  warningMessage(verifyField.goalCategory)
                }
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography style={{ paddingLeft: '31px' }}>
                  {requireField(t("mygoal.label.evaluatorWeight"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item style={{ paddingTop: '10px', paddingBottom: '9px', paddingLeft: '46px' }}>
                <Grid container direction="row">
                  <Grid lg={11}>
                    <TextField error={verifyField.weight && !weight} id="weight" placeholder={t('mygoal.placeholder.weight')} value={weight} onChange={(e) => changeValue(e.target.value, 'weight')} variant="outlined" required fullWidth size="small"
                      style={{ WebkitTextFillColor: !weight ? '#A3A3A3' : '#404349', marginTop: 8, borderColor: verifyField.weight ? '#CC6058' : '#e1e1e1', fontWeight: 400, fontSize: '16px', color: '#404349' }}
                      InputProps={{
                        classes: {
                          notchedOutline: styles.notchedOutline
                        },
                      }}
                    />
                  </Grid>
                  <Grid ml={2} mt={2}>
                    <Typography style={{ fontWeight: 500, fontSize: '18px', color: '#404349' }}>
                      %
                    </Typography>
                  </Grid>
                  {(verifyField.weight && !weight) &&
                    warningMessage(verifyField.weight)
                  }
                </Grid>
              </Grid>
              {(!weight || weight === "0") &&
                <Grid lg={6}>
                </Grid>
              }
              {((goalCategory === backupCategory) ? parseFloat(categoryWeight) - parseFloat(weight) >= 0 && weight > 0 : parseFloat(categoryWeight) - parseFloat(weight) >= 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#5DA196' }}>{'check_circle'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#5DA196' }}>
                        {t("mygoal.label.evaluatorSub")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {((goalCategory === backupCategory) ? parseFloat(categoryWeight) - parseFloat(weight) < 0 && weight > 0 : parseFloat(categoryWeight) - parseFloat(weight) < 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#CC6058' }}>{'cancel'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#CC6058' }}>
                        {`${t('mygoal.label.totalCantBe')} ${(goalCategory === backupCategory) ? ((parseFloat(categoryWeight) - parseFloat(weight)) * -1).toFixed(1) : ((parseFloat(categoryWeight) - parseFloat(weight)) * -1).toFixed(1)} %`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              <Grid lg={6} xs={12} item style={{ paddingTop: '5px', paddingLeft: '45px' }}>
                <Grid item lg={11}>
                  <Grid container direction="row" justifyContent={'space-between'}>
                    <Grid item>
                      <Typography fontSize={16} fontWeight={300} color="#A3A3A3">
                        {`${t('mygoal.label.thisTotal')} 100% `}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" justifyContent={'flex-end'}>
                        <Typography fontSize={16} fontWeight={300} color="#A3A3A3">
                          {t("mygoal.label.remaining")}
                        </Typography>
                        <Typography ml={1}
                          style={{
                            color: (goalCategory === backupCategory)
                              ? parseFloat(categoryWeight) - parseFloat(weight) >= 0 ? '#5DA196'
                                : parseFloat(categoryWeight) - parseFloat(weight) < 0 ? '#CC6058' : '#5DA196' : parseFloat(categoryWeight) - parseFloat(weight) >= 0 ? '#5DA196' : parseFloat(categoryWeight) - parseFloat(weight) < 0 ? '#CC6058' : '#5DA196'
                          }}>
                          {`${(goalCategory === backupCategory) ? (parseFloat(categoryWeight || 0) - parseFloat(weight || 0)).toFixed(1) : (parseFloat(categoryWeight || 0) - parseFloat(weight || 0)).toFixed(1)} % `}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          {((goalType == 1 || goalType == 2) && goalCategory && id != 'quick') &&
            <Box ref={goalMemberRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600} color="#404349">
                    {t("mygoal.label.goalMember")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid container justifyContent="space-between" direction="row">
                  {goalType !== 1
                    ?
                    <Grid item style={{ paddingLeft: '30px' }}>
                      <Typography>
                        {requireField(t("mygoal.label.goalMember"))}
                      </Typography>
                    </Grid>
                    :
                    <Grid item>
                      <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: '500' }}>
                        {t("mygoal.label.goalMember")}
                      </Typography>
                    </Grid>
                  }
                  <Grid item>
                    <Typography fontSize={14} variant="label">
                      {t('mygoal.placeholder.selectMember')}: {memberList?.length} {t('mygoal.placeholder.members')}
                    </Typography>
                  </Grid>
                </Grid>
                {isOwner &&
                  <Grid lg={12} xs={12} item mt={1} style={{ paddingLeft: '30px' }}>
                    <TextField id="outlined-basic" error={verifyField.member && memberList?.length === 0} value={teamSearch} onChange={(e) => searchMember(e.target.value)} placeholder={`Search`} variant="outlined" fullWidth size="small"
                      style={{ borderColor: verifyField.member ? '#CC6058' : '#e1e1e1', WebkitTextFillColor: !teamSearch ? '#A3A3A3' : '#404349' }} />
                  </Grid>
                }
                {(verifyField?.member && memberList?.length === 0) &&
                  <Grid style={{ paddingLeft: '30px' }}>
                    {warningMessage(verifyField.member)}
                  </Grid>
                }
              </Grid>
              {isSearchMember &&
                <Box style={styles.memberSearch}>
                  <Grid container style={{ alignItems: 'center' }}>
                    <Grid item lg={1}>
                      <Checkbox {...label} mb={2} checked={checkedMember} onClick={() => { checkAllMember() }} />
                    </Grid>
                    <Grid item lg={1.5}>
                      <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                        {t('mygoal.etc.employee')}
                      </Typography>
                    </Grid>
                    <Grid item lg={2.5}>
                      <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                        {t('mygoal.etc.name')}
                      </Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography variant="label" style={{ fontSize: '14px', fontWeight: 500, color: '#A0A0A0' }}>
                        {t('mygoal.etc.position')}
                      </Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography variant="label" style={{ fontSize: '14px', fontWeight: 500, color: '#A0A0A0' }}>
                        {t('mygoal.etc.team')}
                      </Typography>
                    </Grid>
                    <Grid item lg={1}>
                      <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                        {t('mygoal.etc.positionType')}
                      </Typography>
                    </Grid>
                    <Grid item lg={1}>
                      <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                        {t('admin.inputForm.goalTemplate')}
                      </Typography>
                    </Grid>
                    <Grid item lg={1} style={{ textAlign: 'right' }}>
                      <Typography color='#404349' style={{ cursor: 'pointer' }} onClick={() => { setIsSearchMember(false); setTeamSearch('') }}>
                        X
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider pt={'10px'} pb={'20px'} />
                  <Box style={{ maxHeight: '205px', overflowY: 'auto' }}>
                    {memberOption?.map((member, idx) => {
                      return (
                        (member?.code.toLowerCase().indexOf(teamSearch.toLowerCase()) >= 0 ||
                          member?.firstName.toLowerCase().indexOf(teamSearch.toLowerCase()) >= 0 ||
                          member?.lastName.toLowerCase().indexOf(teamSearch.toLowerCase()) >= 0 ||
                          member?.empSubName.toLowerCase().indexOf(teamSearch.toLowerCase()) >= 0 ||
                          member?.empName.toLowerCase().indexOf(teamSearch.toLowerCase()) >= 0 ||
                          member?.empPositionType.toLowerCase().indexOf(teamSearch.toLowerCase()) >= 0
                        ) &&
                        <Grid container key={idx} style={{ alignItems: 'center' }}>
                          <Grid item lg={1}>
                            <Checkbox {...label} checked={memberList.some((list) => list.formEvaluateID === member.formEvaluateID)} onClick={() => { manageMemberList(member) }} />
                          </Grid>
                          <Grid item lg={1.5}>
                            <Typography style={{ fontSize: '16px', fontWeight: 400, color: '#404349' }}>
                              {member?.code}
                            </Typography>
                          </Grid>
                          <Grid item lg={2.5}>
                            <Typography style={{ fontSize: '16px', fontWeight: 400, color: '#404349' }}>
                              {member?.firstName} {member?.lastName}
                            </Typography>
                          </Grid>
                          <Grid item lg={2}>
                            <Typography style={{ fontSize: '16px', fontWeight: 400, color: '#404349' }}>
                              {member?.empSubName}
                            </Typography>
                          </Grid>
                          <Grid item lg={2}>
                            <Typography style={{ fontSize: '16px', fontWeight: 400, color: '#404349' }}>
                              {member?.empName}
                            </Typography>
                          </Grid>
                          <Grid item lg={1}>
                            <Typography style={{ fontSize: '16px', fontWeight: 400, color: '#404349' }}>
                              {member?.empPositionType}
                            </Typography>
                          </Grid>
                          <Grid item lg={1}>
                            <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#404349' }}>
                              {member?.template}
                            </Typography>
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Box>
                </Box>
              }
              {(memberList.length > 0 && isSearchMember === false) &&
                <Box style={{ maxHeight: '300px', marginTop: '20px', width: "100%", overflowY: 'scroll', overflowX: 'hidden', paddingLeft: '30px' }}>
                  <Table aria-label="simple table">
                    <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                      <TableRow>
                        {headerMember?.map((header, idx) => {
                          return (
                            <TableCell align="left" sortDirection="asc" display="flex"
                              className="clickable"
                              key={idx}
                              onClick={() => handleRequestSort(header.field)}>
                              <Typography
                                fontWeight={500}
                                fontSize={16}
                                lineHeight="24px"
                                sx={{ color: "#A0A0A0" }}
                              >
                                {header.headerName}
                                {idx != (headerMember.length - 1)
                                  ?
                                  <TableSortLabel
                                    active={orderBy === header.field}
                                    direction={orderBy === header.field ? order : 'asc'}
                                  />
                                  :
                                  isOwner &&
                                  <Typography textAlign="right" style={{ textDecoration: "underline" }} fontSize={14} onClick={() => { removeAllSelect() }}>
                                    {t('mygoal.etc.clearAll')}
                                  </Typography>
                                }
                              </Typography>
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {memberList.length > 0 && (
                        stableSort(memberList, getComparator(order, orderBy)).map((row, idx) =>
                          row == null ? (
                            <></>
                          ) : (
                            <TableRow
                              key={row.id}
                              sx={{
                                overflowY: 'auto'
                              }}
                            >
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box
                                  display="flex"
                                  sx={{
                                    flexFlow: "column",
                                    textAlign: "left",
                                    position: "relative",
                                  }}
                                >
                                  <Typography
                                    fontWeight={400}
                                    fontSize={18}
                                    lineHeight="27px"
                                  >
                                    {row.code}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={400}
                                      fontSize={18}
                                      lineHeight="27px"
                                    >
                                      {row.firstName} {row.lastName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={400}
                                      fontSize={18}
                                      lineHeight="27px"
                                    >
                                      {row.empSubName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={400}
                                      fontSize={18}
                                      lineHeight="27px"
                                    >
                                      {row.empName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={400}
                                      fontSize={14}
                                      lineHeight="27px"
                                    >
                                      {row.template}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    {(row.goalCategoryDetail && Object.keys(row.goalCategoryDetail).length > 0 && !row.deleteFlag)
                                      ?
                                      <Typography
                                        fontWeight={400}
                                        fontSize={14}
                                        lineHeight="27px"
                                      >
                                        {row.goalCategoryDetail?.name}
                                      </Typography>
                                      :
                                      <FormControl style={{ width: '350px' }}>
                                        <Select
                                          displayEmpty
                                          error={verifyField.selectGoalCategory}
                                          labelId="category"
                                          id="category"
                                          value={row.selectGoalCategory}
                                          onChange={(val) => { handleChangeObject(val.target.value, idx, 'member') }}
                                          input={<OutlinedInput size="small" style={{ width: '350px' }} />}
                                          renderValue={(selected) => {
                                            if (selected == null) {
                                              return <Typography></Typography>;
                                            } else {
                                              return <Typography style={{ color: '#404349' }}>{row?.empCategories?.find((item) => item.serial === selected)?.name}</Typography>
                                            }
                                          }}
                                        >
                                          {row?.empCategories?.map((option, idx) => {
                                            return <MenuItem key={idx} value={option.serial}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.name}</Typography></MenuItem>
                                          })}
                                        </Select>
                                      </FormControl>
                                    }
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="right" style={{ borderBottom: 0 }}>
                                <Box display="flex" justifyContent="flex-end">
                                  {isOwner &&
                                    <Box
                                      display="flex"
                                      justifyContent="flex-end"
                                      sx={{ flexFlow: "column" }}
                                    >
                                      <Typography
                                        fontWeight={350}
                                        fontSize={16}
                                        lineHeight="27px"
                                        variant="label"
                                        textAlign="right"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => { removeMember(idx) }}
                                      >
                                        X
                                      </Typography>
                                    </Box>
                                  }
                                </Box>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      )}
                    </TableBody>
                  </Table>
                </Box>
              }
            </Box>
          }
          {id != 'quick' &&
            <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                    {t("mygoal.label.evaluatorPermission")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} pr={6} pl={'33px'}>
                <Grid lg={12} xs={12} style={{ display: 'none' }} item>
                  <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: 500 }}>
                    {t("mygoal.label.alternate")}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item style={{ marginRight: 25, paddingTop: '10px', paddingBottom: '9px', display: 'none' }}>
                  {/* <FormControl sx={{ m: 1, minWidth: 80, ml: 0, mt: 0 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={evaluator}
                      onChange={(val) => {handleChange(val.target.value, 'evaluator')}}
                      input={<OutlinedInput size="small" />}
                      disabled={!isOwner}
                      classes={!isOwner ? { select : classes.disabled } :  {}}
                      renderValue={(selected) => {
                        if(selected == null) {
                          return <Typography style={{color: '#00000030', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px'}}>{t('mygoal.placeholder.evaluator')}</Typography>;
                        } else {
                          return <Typography style={{fontWeight: '400', fontSize: '16px', color: '#404349'}}>
                            {`${selectOption?.evaluator?.find((item) => item.serial === selected)?.firstName} ${selectOption?.evaluator?.find((item) => item.serial === selected)?.lastName}`}
                        </Typography>;
                        }
                      }}
                    >
                      <MenuItem value={null}>
                        <Typography style={{color: '#A3A3A3', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px'}}>{t('mygoal.placeholder.evaluator')}</Typography>
                      </MenuItem>
                      {selectOption?.evaluator?.map((option, idx) => {
                        return <MenuItem key={idx} value={option.serial}>
                          <Typography style={{fontWeight: 400, fontSize: '16px', color: '#404349'}}>{`${option.firstName} ${option.lastName}`}</Typography>
                        </MenuItem>
                      })}
                    </Select>
                  </FormControl> */}
                  <Autocomplete
                    id="checkboxes-tags-demo"
                    size="small"
                    fullWidth
                    options={selectOption?.evaluator}
                    disableCloseOnSelect
                    value={evaluator}
                    onChange={(event, newValue) => {
                      handleChange(newValue, "evaluator")
                    }}
                    disabled={!isOwner}
                    getOptionLabel={(option) => (option?.firstName !== undefined ? option?.firstName + ' ' + option?.lastName : option.full_name)}
                    style={{ width: "100%" }}
                    classes={!isOwner ? { input: classes.disabled, inputRoot: classes.disabled } : {}}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`Select`}
                        InputLabelProps={{
                          ...params.inputProps,
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid lg={12} xs={12} item>
                  <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: 500 }}>
                    {t("mygoal.label.permission")}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item style={{ marginRight: 25, paddingTop: '10px', paddingBottom: '9px' }}>
                  <FormControl sx={{ m: 1, minWidth: 80, ml: 0, mt: 0 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={permission}
                      onChange={(val) => { handleChange(val.target.value, 'permission') }}
                      input={<OutlinedInput size="small" />}
                      disabled={!isOwner}
                      classes={!isOwner ? { select: classes.disabled } : {}}
                      renderValue={(selected) => {
                        if (selected == null) {
                          return <Typography style={{ color: '#00000030', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '14px' }}>{t('mygoal.placeholder.permission')}</Typography>;
                        } else {
                          return <Typography style={{ fontWeight: '400', fontSize: '16px', color: '#404349' }}>
                            {i18n.language === "th-TH" ? selectOption?.permission?.find((item) => item.value === selected)?.descriptionTh : selectOption?.permission?.find((item) => item.value === selected)?.descriptionEn}
                          </Typography>;
                        }
                      }}
                    >
                      {/* <MenuItem disabled value="">
                        <Typography style={{color: '#00000030', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '14px'}}>{t('mygoal.placeholder.permission')}</Typography>
                      </MenuItem> */}
                      {selectOption?.permission?.map((option, idx) => {
                        return <MenuItem key={idx} value={option.value}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>
                          {i18n.language === "th-TH" ? option.descriptionTh : option.descriptionEn}
                        </Typography></MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          }
          {(goalCategory && id != 'quick') &&
            <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                    {t('mygoal.label.goalAlignments')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginLeft: '20px', paddingRight: '50px' }}>
                {/* {((id === 'edit' && originalAlignment !== 2) || id !== 'edit') && */}
                <Grid lg={2} xs={12} item>
                  <Card style={isLinking ? { border: '1px solid #5DA196', cursor: 'pointer', width: '150px', height: '150px', borderRadius: 10 } : { border: '1px solid #DADADA', cursor: 'pointer', width: '150px', height: '150px', borderRadius: 10 }} onClick={() => isOwner ? checkLinking() : {}}>
                    <CardContent style={{ padding: 0 }}>
                      <Grid item lg={12} xs={12} container textAlign="center">
                        <Grid item>
                          <Checkbox name="checkbox" value="1" checked={isLinking} size="small" disabled={!isOwner} />
                        </Grid>
                        <Grid item lg={12}>
                          {isLinking ? <LinkActive style={{ width: 112, height: 42 }} /> : <LinkInactive style={{ width: 112, height: 42 }} />}
                        </Grid>
                        <Grid item lg={12} mt={goalType !== 2 ? 4.3 : 0}>
                          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349">
                            {t('mygoal.label.linking')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {/* } */}
                {((goalType !== 2 && id !== 'edit') || (id === 'edit' && goalType !== 2)) &&
                  <Grid lg={2} xs={12} item>
                    <Card style={isCascade ? { border: '1px solid #5DA196', cursor: 'pointer', width: '150px', height: '150px', borderRadius: 10 } : { border: '1px solid #DADADA', cursor: 'pointer', width: '150px', height: '150px', borderRadius: 10 }} onClick={() => isOwner ? checkCascade() : {}}>
                      <CardContent style={{ padding: 0 }}>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Checkbox name="checkbox" value="2" checked={isCascade} size="small" disabled={!isOwner} />
                          </Grid>
                          <Grid item lg={12}>
                            {isCascade ? <CasActive style={{ height: 76, width: 91 }} /> : <CasInactive style={{ height: 76, width: 91 }} />}
                          </Grid>
                          <Grid item lg={12}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349">
                              {t('mygoal.label.cascade')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                }
                {isLinking &&
                  <Grid lg={8} item>
                  </Grid>
                }
                {id === 'edit' && isCascade &&
                  <Grid lg={10} item>
                  </Grid>
                }
                {isLinking &&
                  <Grid lg={3} xs={3} item>
                    <Typography>
                      {requireField(t('mygoal.label.linkingType'))}
                    </Typography>
                  </Grid>
                }
                {isLinking &&
                  <Grid lg={9} xs={9} item>
                    <Typography>
                      {requireField(t('mygoal.label.linking'))}
                    </Typography>
                  </Grid>
                }
                {isLinking &&
                  <Grid lg={3} xs={3} item style={{ paddingTop: '10px', paddingBottom: '9px' }} >
                    <FormControl sx={{ m: 1, minWidth: 80, mt: 0, ml: 0 }} fullWidth>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        value={type}
                        onChange={(val) => { handleChange(val.target.value, 'type') }}
                        input={<OutlinedInput size="small" />}
                        error={verifyField.alignment && !type}
                        disabled={!isOwner}
                        classes={!isOwner ? { select: classes.disabled } : {}}
                        renderValue={(selected) => {
                          if (selected?.length == 0) {
                            return <Typography style={{ color: '#A3A3A370', "-webkit-text-fill-color": "initial", fontStyle: 'normal' }}>{t('mygoal.placeholder.linkingType')}</Typography>;
                          } else {
                            return selected
                          }
                        }}
                      >
                        {/* <MenuItem disabled value="">
                          <Typography style={{color: '#A3A3A3', "-webkit-text-fill-color": "initial", fontStyle: 'normal'}}>{t('mygoal.placeholder.linkingType')}</Typography>
                        </MenuItem> */}
                        {selectOption?.type?.map((option, idx) => {
                          return <MenuItem key={idx} value={option}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option}</Typography></MenuItem>
                        })}
                      </Select>
                    </FormControl>
                    {(verifyField.alignment && !type) &&
                      warningMessage(verifyField.alignment)
                    }
                  </Grid>
                }
                {isLinking &&
                  <Grid lg={9} xs={9} item style={{ paddingTop: '10px' }}>
                    <Autocomplete
                      id="checkboxes-tags-demo"
                      size="small"
                      fullWidth
                      options={selectOption?.value}
                      disableCloseOnSelect
                      value={value}
                      onChange={(event, newValue) => {
                        handleChange(newValue, "value")
                      }}
                      getOptionLabel={(option) => option?.name?.length > 100 ? option?.name?.substr(0, 100) + '...' : option?.name}
                      disabled={!isOwner}
                      classes={!isOwner ? { input: classes.disabled, inputRoot: classes.disabled } : {}}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={`Select`}
                          InputLabelProps={{
                            ...params.inputProps,
                            shrink: true,
                          }}
                        />
                      )}
                      renderOption={(props, option, { selected }) => (
                        <li {...props} key={`listItem-${option.serial}-${option.employee.first_name}-${option.employee.last_name}`}>
                          <ul style={{ listStyleType: 'none' }}>
                            <li style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>
                              {option.name.length > 100 ? option.name.substr(0, 100) + '...' : option.name}
                            </li>
                            <li style={{ fontWeight: 400, fontSize: '14px', color: '#A3A3A3' }}>
                              {`(${t('mygoal.placeholder.goalOwner')}: ${option.employee.first_name}  ${option.employee.last_name})`}
                            </li>
                          </ul>
                        </li>
                      )}
                    />
                    {(verifyField.alignment && !value) &&
                      warningMessage(verifyField.alignment)
                    }
                  </Grid>
                }
                {isCascade &&
                  <Grid lg={9} xs={12} item>
                    <Typography>
                      {requireField(t('mygoal.label.alignmentMember'))}
                    </Typography>
                  </Grid>
                }
                {isCascade &&
                  <Grid lg={3} style={{ paddingTop: '15px' }}>
                    <Grid container pt={0} justifyContent={'right'}>
                      <Grid>
                        <Typography fontSize={16} variant="label" mr={"3px"} fontWeight={300}>
                          {`${t('mygoal.label.alignmentMembers')} `}
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography fontSize={16} variant="label" mr={"3px"} style={{ color: '#5DA196' }} fontWeight={300}>
                          {`${alignmentList.length}`}
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography fontSize={16} variant="label" fontWeight={300}>
                          {`${t('mygoal.label.members')}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                }
                {(isCascade && isOwner) &&
                  <Grid lg={12} xs={12} item>
                    <TextField style={{ WebkitTextFillColor: !alignmentSearch ? '#A3A3A3' : '#404349', color: '#A3A3A3', fontSize: '16px' }} error={verifyField.alignment && alignmentList.length === 0} id="outlined-basic" value={alignmentSearch} onChange={(e) => searchAlignment(e.target.value)} placeholder={`Select your assigned members`} variant="outlined" fullWidth size="small" />
                    {(isCascade && verifyField.alignment && alignmentList.length === 0) &&
                      warningMessage(verifyField.alignment)
                    }
                  </Grid>
                }

                {(isCascade && isSearchAlignment) &&
                  <Box style={styles.alignmentSearch}>
                    <Grid container style={{ alignItems: 'center' }}>
                      <Grid item lg={1}>
                        <Checkbox {...label} mb={2} checked={checkedAlignment} onClick={() => { checkAllAlignment() }} />
                      </Grid>
                      <Grid item lg={1.5}>
                        <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                          {t('mygoal.etc.employee')}
                        </Typography>
                      </Grid>
                      <Grid item lg={2.5}>
                        <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                          {t('mygoal.etc.name')}
                        </Typography>
                      </Grid>
                      <Grid item lg={2}>
                        <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                          {t('mygoal.etc.position')}
                        </Typography>
                      </Grid>
                      <Grid item lg={1}>
                        <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                          {t('mygoal.etc.positionType')}
                        </Typography>
                      </Grid>
                      <Grid item lg={3}>
                        <Typography variant="label" style={{ fontSize: '16px', fontWeight: 500, color: '#A0A0A0' }}>
                          {t('label.formName')}
                        </Typography>
                      </Grid>
                      <Grid item lg={1} style={{ textAlign: 'right' }}>
                        <Typography color='#5DA196' style={{ cursor: 'pointer' }} onClick={() => { setIsSearchAlignment(false); setAlignmentSearch('') }}>
                          X
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider pt={'10px'} pb={'20px'} />
                    <Box style={{ maxHeight: '205px', overflowY: 'auto' }}>
                      {memberOption?.filter((m) => m.formStatus == 'draft')?.map((member, idx) => {
                        return (
                          (member?.code.toLowerCase().indexOf(alignmentSearch?.toLowerCase()) >= 0 ||
                            member?.firstName.toLowerCase().indexOf(alignmentSearch?.toLowerCase()) >= 0 ||
                            member?.lastName.toLowerCase().indexOf(alignmentSearch?.toLowerCase()) >= 0 ||
                            member?.empSubName.toLowerCase().indexOf(alignmentSearch?.toLowerCase()) >= 0 ||
                            member?.empName.toLowerCase().indexOf(alignmentSearch?.toLowerCase()) >= 0 ||
                            member?.empPositionType.toLowerCase().indexOf(alignmentSearch?.toLowerCase()) >= 0
                          ) &&
                          <Grid container key={idx} style={{ alignItems: 'center' }}>
                            <Grid item lg={1}>
                              {/* approvalStatus === 'new' disabled={alignmentList.some((list) => list.code === member.code && list.goalCategoryDetail)} */}
                              <Checkbox {...label} checked={alignmentList.length > 0 ? alignmentList.some((list) => list.formEvaluateID === member.formEvaluateID) : false} onClick={() => { manageAlignemntList(member) }} />
                            </Grid>
                            <Grid item lg={1.5}>
                              <Typography style={{ fontSize: '18px', fontWeight: 400, color: '#404349' }}>
                                {member?.code}
                              </Typography>
                            </Grid>
                            <Grid item lg={2.5}>
                              <Typography style={{ fontSize: '18px', fontWeight: 400, color: '#404349' }}>
                                {member?.firstName} {member?.lastName}
                              </Typography>
                            </Grid>
                            <Grid item lg={2}>
                              <Typography style={{ fontSize: '18px', fontWeight: 400, color: '#404349' }}>
                                {member?.empSubName}
                              </Typography>
                              <Typography style={{ fontSize: '12px', fontWeight: 200, color: '#404349' }}>
                                {member?.empName}
                              </Typography>
                            </Grid>
                            <Grid item lg={1}>
                              <Typography style={{ fontSize: '18px', fontWeight: 400, color: '#404349' }}>
                                {member?.empPositionType}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography style={{ fontSize: '18px', fontWeight: 400, color: '#404349' }}>
                                {member?.formName}
                              </Typography>
                            </Grid>
                          </Grid>
                        )
                      })}
                    </Box>
                  </Box>
                }
                {(isCascade && alignmentList.length > 0 && isSearchAlignment === false) &&
                  <Box style={{ maxHeight: '300px', marginTop: '20px', width: "100%", overflowY: 'scroll', overflowX: 'hidden', paddingLeft: '18px' }}>
                    <Table aria-label="simple table">
                      <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                        <TableRow>
                          {headerMember?.map((header, idx) => {
                            return (
                              <TableCell align="left" sortDirection="asc" display="flex"
                                className="clickable"
                                key={idx}
                                onClick={() => handleRequestSort(header.field)}>
                                <Typography
                                  fontWeight={500}
                                  fontSize={16}
                                  lineHeight="24px"
                                  sx={{ color: "#A0A0A0" }}
                                >
                                  {header.headerName}
                                  {idx != (headerMember.length - 1)
                                    ?
                                    <TableSortLabel
                                      active={orderBy === header.field}
                                      direction={orderBy === header.field ? order : 'asc'}
                                    />
                                    :
                                    isOwner &&
                                    <Typography textAlign="right" style={{ textDecoration: "underline" }} fontSize={14} onClick={() => approvalStatus === 'new' ? removeAllAlignment() : removeAlignmentSelect()} >
                                      {t('mygoal.etc.clearAll')}
                                    </Typography>
                                  }
                                </Typography>
                              </TableCell>
                            )
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {alignmentList.length > 0 && (
                          stableSort(alignmentList, getComparator(order, orderBy)).map((row, idx) =>
                            row == null ? (
                              <></>
                            ) : (
                              <TableRow
                                key={row.id}
                                sx={{
                                  overflowY: 'auto'
                                }}
                              >
                                <TableCell align="left" style={{ borderBottom: 0 }}>
                                  <Box
                                    display="flex"
                                    sx={{
                                      flexFlow: "column",
                                      textAlign: "left",
                                      position: "relative",
                                    }}
                                  >
                                    <Typography
                                      fontWeight={400}
                                      fontSize={18}
                                      lineHeight="27px"
                                    >
                                      {row.code}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell align="left" style={{ borderBottom: 0 }}>
                                  <Box display="flex">
                                    <Box
                                      display="flex"
                                      sx={{ flexFlow: "column" }}
                                    >
                                      <Typography
                                        fontWeight={400}
                                        fontSize={18}
                                        lineHeight="27px"
                                      >
                                        {row.firstName} {row.lastName}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell align="left" style={{ borderBottom: 0 }}>
                                  <Box display="flex">
                                    <Box
                                      display="flex"
                                      alignItems="flex-start"
                                      sx={{ flexFlow: "column" }}
                                    >
                                      <Typography
                                        fontWeight={400}
                                        fontSize={18}
                                        lineHeight="27px"
                                      >
                                        {row.empSubName}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell align="left" style={{ borderBottom: 0 }}>
                                  <Box display="flex">
                                    <Box
                                      display="flex"
                                      alignItems="flex-start"
                                      sx={{ flexFlow: "column" }}
                                    >
                                      <Typography
                                        fontWeight={400}
                                        fontSize={18}
                                        lineHeight="27px"
                                      >
                                        {row.empName}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell align="left" style={{ borderBottom: 0 }}>
                                  <Box display="flex">
                                    <Box
                                      display="flex"
                                      alignItems="flex-start"
                                      sx={{ flexFlow: "column" }}
                                    >
                                      <Typography
                                        fontWeight={400}
                                        fontSize={16}
                                        lineHeight="27px"
                                      >
                                        {row.template}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell align="left" style={{ borderBottom: 0 }}>
                                  <Box display="flex">
                                    <Box
                                      display="flex"
                                      alignItems="flex-start"
                                      sx={{ flexFlow: "column" }}
                                    >
                                      {(row.goalCategoryDetail && Object.keys(row.goalCategoryDetail).length > 0)
                                        ?
                                        <Typography
                                          fontWeight={400}
                                          fontSize={18}
                                          lineHeight="27px"
                                        >
                                          {row.goalCategoryDetail?.name}
                                        </Typography>
                                        :
                                        <FormControl style={{ width: '350px' }}>
                                          <Select
                                            displayEmpty
                                            error={verifyField.selectAlignmentGoalCategory}
                                            labelId="category"
                                            id="category"
                                            value={row.selectGoalCategory}
                                            onChange={(val) => { handleChangeObject(val.target.value, idx, 'alignment') }}
                                            input={<OutlinedInput size="small" style={{ width: '350px' }} />}
                                            renderValue={(selected) => {
                                              if (selected == null) {
                                                return <Typography></Typography>;
                                              } else {
                                                return <Typography style={{ color: '#404349' }}>{row?.empCategories?.find((item) => item.serial === selected).name}</Typography>
                                              }
                                            }}
                                          >
                                            {row?.empCategories?.map((option, idx) => {
                                              return <MenuItem style={{ width: '350px' }} key={idx} value={option.serial}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.name}</Typography></MenuItem>
                                            })}
                                          </Select>
                                        </FormControl>
                                      }
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell align="right" style={{ borderBottom: 0 }}>
                                  <Box display="flex" justifyContent="flex-end">
                                    {(approvalStatus === 'new' || (!row.goalCategoryDetail?.name && approvalStatus !== 'new')) &&
                                      <Box
                                        display="flex"
                                        justifyContent="flex-end"
                                        sx={{ flexFlow: "column" }}
                                      >
                                        <Typography
                                          fontWeight={400}
                                          fontSize={18}
                                          lineHeight="27px"
                                          variant="label"
                                          textAlign="right"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => { removeAlignment(idx) }}
                                        >
                                          X
                                        </Typography>
                                      </Box>
                                    }
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )
                          )
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                }
                {/* {goalAlignment === 1 &&
                  <Grid lg={12} xs={12} item style={{paddingTop: '5px'}}>
                    <Grid container pt={0}>
                      <Grid>
                        <Typography fontSize={16} variant="label" mr={"3px"} fontWeight={300}>
                          {`Linked goal: `}
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography fontSize={16} variant="label" mr={"3px"} style={{color: '#5DA196'}} fontWeight={300}>
                          {`${value.length}`}
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography fontSize={16} variant="label" fontWeight={300}>
                          {` items`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                } */}
              </Grid>
            </Box>
          }

          {(state.isEvaluator) &&
            <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600} color={'#404349'}>
                    {requireField(t("mygoal.label.remark"))}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} pr={6} pl={'33px'}>
                <Grid lg={12} xs={12} item style={{ marginRight: 25, paddingTop: '10px', paddingBottom: '9px' }}>
                  <TextField
                    multiline
                    rows={4}
                    error={verifyField.remark} onChange={(e) => changeValue(e.target.value, 'remark')}
                    value={remark} variant="outlined"
                    required fullWidth size="small"
                    style={{ WebkitTextFillColor: !remark ? '#A3A3A3' : '#404349', fontWeight: !remark ? '300' : '400', fontSize: '16px', borderColor: verifyField.remark ? '#CC6058' : '#e1e1e1', paddingTop: '7px', backgroundColor: !isOwner ? '#F3F3F3!important' : '' }}
                    sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                    InputProps={!isOwner ? { className: classes.disabled } : {}}
                    disabled={!isOwner}
                  />
                  {(verifyField.remark && !remark) &&
                    warningMessage(verifyField.remark)
                  }
                </Grid>
              </Grid>
            </Box>
          }

          <Grid container direction="row">
            <Grid container lg={1} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => { changing ? openCancelDialog(true) : handleCancelDialog() }}>
              <Grid item mt={0.5}>
                <BackIcon />
              </Grid>
              <Grid item ml={1}>
                <Typography>
                  {t('label.back')}
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={10} xs={12} item textAlign="center">
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => { checkField() }}
                color="primary"
                variant="contained"
                style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
              >
                <Typography>{id === 'edit' ? t('label.save') : t('mygoal.label.createGoal')}</Typography>
              </Button>
            </Grid>
          </Grid>
          <WarningDialog open={isCancelDialogOpen} doConfirm={handleCancelDialog} setValue={openHandleCancel} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
          <WarningDialog open={isSaveDialogOpen} doConfirm={handleSaveDialog} setValue={openHandleSave} title={t('label.confirmationOfChange')} text={t('mygoal.popup.confirmChangeDesc2')} />
          <WarningDialog open={isConfirmEditOpen} doConfirm={() => confirmPage()} setValue={openConfirmEditOpen} title={t('label.confirmationOfChange')} text={t('mygoal.popup.confirmChangeDesc2')} />
          <SimpleDialog page={true} open={isSuccessEditOpen} setValue={openSuccessEditOpen} doDirect={() => handleSuccessEdit()} title={t('mygoal.popup.success')} text={t('mygoal.popup.goalSaved')} />
        </Container>
      </Box>
    </>
  );
};
export default MyGoalCreateForm;
